/* eslint-disable no-unused-vars */

import { useEffect, useRef, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import {
  yellow,
  grey,
  purple,
  orange,
  green,
  blue,
  red,
  teal,
} from "@mui/material/colors";
import SearchBar from "./SearchBar";
import { Grid, Button, CircularProgress, Typography } from "@mui/material";
import SaleList from "./SaleList";
import SaleSummary from "./SaleSummary";
import SaleDao from "./SaleDao";
import db from "../../db/db";
import MPaymentWindow from "./payment/MPaymentWindow";
import { v4 as uuidv4 } from "uuid";
import { SaleUtils } from "../../utils/SaleUtils";
import { PricingUtils } from "../../utils/PricingUtils";
import MSaleHistory from "./MSaleHistory";
import HistoryIcon from "@mui/icons-material/Restore";
import MList from "../../components/pos/MList";
import MValueCapture from "./MValueCapture";
import SearchIcon from "@mui/icons-material/Search";
import MOpenQtyPrice from "./MOpenQtyPrice";
import MCustomFields from "./MCustomFields";
import MCustomerSearch from "./MCustomerSearch";
import MServiceSummary from "./MServiceSummary";
import MServiceDetails from "./MServiceDetails";
import MEditService from "./MEditService";
import API from "../../utils/API";
import RightActionPanel from "./RightActionPanel";
import { PoleDisplayUtils } from "../../utils/PoleDisplayUtils";
import DigitPanel from "./DigitPanel";
import { AgentUtils } from "../../utils/AgentUtils";
import ProductLookup from "./ProductLookup";
import PDialog from "../../components/pos/PDialog";
import HoldCrud from "./HoldCrud";
import UnHoldCrud from "./UnHoldCrud";
import CustomerLookupNew from "../customer/CustomerLookupNew";
import LastSaleSummary from "./LastSaleSummary";
import ServiceDetailsPanel from "./ServiceDetailsPanel";
import { Store } from "../../utils/Store";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Payin from "../Cashflow/payin/PayinCrud";
import { SyncUtils } from "../../utils/SyncUtils";
import TSaleList from "./TSaleList";
import SaleDetailsPanal from "./SaleDetailsPanel";
import TradingActionPanel from "./TradingActionPanel";
import ProductList from "../product/ProductList";
import ProductTileView from "./ProductTileView";
import RestaurantActionPanel from "./RestaurantActionPanel";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import IconButton from "@mui/material/IconButton";
import RestaurantHome from "../RestaurantHome";
import TableSelector from "./TableSelector";
import SalesManSelector from "./SalesManSelector";
import DeliveryDiningTwoToneIcon from "@mui/icons-material/DeliveryDiningTwoTone";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import { PrintUtils } from "../../utils/PrintUtils";
import TSaleListRo from "./TSaleListRo";
import PAuthenticationWindow from "../../components/pos/PAuthenticationWindow";
import PConfirm from "../../components/pos/PConfirm";
import ProductSearch from "./product_search/productSearch";
import { StringUtils } from "../../utils/StringUtils";
import CustomerCrud from "../customer/CustomerCrud";
const theme = createTheme({});

const ActionButtonOrange = styled(Button)({
  width: "100%",
  fontSize: "1.28rem",

  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
});

const ActionButtonOrangeSmallFont = styled(Button)({
  width: "100%",
  height: "48px",

  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: orange[500],
  "&:hover": {
    backgroundColor: orange[700],
  },
});

const MenuButton = styled(Button)({
  width: "100%",
  fontSize: "0.70rem",
  height: "50px",
});

const QueueButton = styled(Button)({
  width: "100%",
  fontSize: "0.55rem",
  height: "30px",
});

const ActionButton = styled(Button)({
  width: "100%",
  fontSize: "0.750rem",
});

const PaymentButton = styled(Button)({
  width: "100%",
  fontSize: "1.28rem",

  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: green[500],
  "&:hover": {
    backgroundColor: green[700],
  },
});

export default function MSaleWindow(props) {
  const { t } = useTranslation();
  const [saleData, setSaleData] = useState([]);
  const [rawSale, setRawSale] = useState([]);
  const [returnFlag, setReturnFlag] = useState(false);
  const [colorPallet, setColorPallet] = useState([]);
  const [customerBean, setCustomerBean] = useState(null);
  const [customerBeanForHold, setCustomerBeanForHold] = useState(null);

  const [customFields, setCustomFields] = useState([]);

  const [isCustomFieldRequired, setIsCustomFieldRequired] = useState(false);
  const [saleSetting, setSaleSetting] = useState();
  const [storeAdminSetting, setStoreAdminSetting] = useState();
  const [saleListEngine, setSaleListEngine] = useState("");

  const [initSaleFlag, setIntiSaleFlag] = useState(false);

  const [currentScreen, setCurrentScreen] = useState(
    props.context.appMode === "mobile" && props.context.appType === "R_POS"
      ? "dineIn_home"
      : "sale"
  );
  const [parentSaleBean, setParentSaleBean] = useState(null);

  const [pricingBean, setPricingBean] = useState(null);
  const [productBean, setProductBean] = useState(null);
  const [productKey, setProductKey] = useState(null);
  const [parentType, setParentType] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);

  const [value, setValue] = useState(null);

  const [srNumber, setSrNumber] = useState("NEW");
  const [srStatus, setSrStatus] = useState(null);
  const [srAssignee, setSrAssignee] = useState(null);
  const [srAssigneeLabel, setSrAssigneeLabel] = useState("Assign");
  const [srEta, setSrEta] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [uuid, setUuid] = useState(null);
  const [intVersion, setIntVersion] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [showProductLookup, setShowProductLookup] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [holdId, setHoldId] = useState(null);
  const [holdNote, setHoldNote] = useState("");
  const [showHoldWindow, setShowHoldWindow] = useState(false);
  const [showUnHoldWindow, setShowUnHoldWindow] = useState(false);
  const [showCustomerLookupWindow, setShowCustomerLookupWindow] =
    useState(false);

  const [showCustomerCrud, setShowCustomerCrud] = useState(false); // this usestate is used for trading screen (add new customer)

  const [showPaymentScreen, setShowPaymentScreen] = useState(false);
  const [showValueCapture, setShowValueCapture] = useState(false);

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [lastBill, setLastBill] = useState(null);
  const [showLastSaleSummary, setShowLastSaleSummary] = useState(true);
  const [privileges, setPrivileges] = useState(props.context.privileges);
  const [currentUser, setCurrentUser] = useState("");
  const [cacheLoaded, setCacheLoaded] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [workflowStatus, setworkflowStatus] = useState("NEW");
  const [showTableSelector, setShowTableSelector] = useState(false);
  const [tradingDate, setTradingDate] = useState();
  const [enableKot, setEnableKot] = useState(true);
  const [allowBarcodeScan, setAllowBarcodeScan] = useState(true);
  const [paymentSettings, setPaymentSettings] = useState({});

  const [tableSelectionEventSource, setTableSelectionEventSource] =
    useState(null);

  const [tableInfo, setTableInfo] = useState([]);
  const [salesManInfo, setSalesManInfo] = useState({});
  const [showDeliveryPersonLookup, seltShowDeliveryPersonLookup] =
    useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });

  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const [salesMans, setSalesMans] = useState([]);
  const [clockPrefix, setClockPrefix] = useState("");
  const [nextInvoiceNo, setNextInvoiceNo] = useState("");

  const [showProductSearch, setShowProductSearch] = useState(false);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [rUnitTypeOptions, setRUnitTypeOptions] = useState([]);
  const [productInfoFields, setProductInfoFields] = useState([]);
  const [from, setFrom] = useState("m_sale_window");

  let takeAwaySync = false;
  let deliverySync = false;
  let dineInSYnc = false;
  //let onlineSync = false;

  const [payCodeConfigs, setPayCodeConfigs] = useState({
    SALE: [
      { code: "CASH", value: "CASH", selected: true },
      { code: "CARD", value: "CARD", selected: false },
      { code: "CREDIT", value: "CREDIT", selected: false },
      { code: "DISCOUNT", value: "DISCOUNT", selected: false },
    ],
    SALE_RETURN: [{ code: "CASH", value: "CASH", selected: true }],
    SALE_ORDER: [
      { code: "CASH", value: "CASH", selected: true },
      { code: "CARD", value: "CARD", selected: false },
    ],
    SERVICE: [
      { code: "CASH", value: "CASH", selected: true },
      { code: "CARD", value: "CARD", selected: false },
      { code: "CREDIT", value: "CREDIT", selected: false },
    ],
  });

  const [terminalOptions, setTerminalOptions] = useState([]);

  const [statusOptions, setStausOptions] = useState([
    { name: "Open", id: "OPEN" },
    { name: "In Progress", id: "IN_PROGRESS" },
    { name: "Work Completed", id: "WORK COMPLETED" },
    { name: "Closed", id: "CLOSED" },
  ]);

  const [serviceDataMode, setServiceDataMode] = useState("");

  //RPOS
  const [currentMenu, setCurrentMenu] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState({});
  const [currentQueue, setCurrentQueue] = useState([]);
  const [rMenuCount, setRMenuCount] = useState(0);
  const [showAuthScreen, setShowAuthScreen] = useState(false);
  const [tradingScreenPaymentModeSelect, setTradingScreenPaymentModeSelect] =
    useState("");

  useEffect(() => {
    if (showAuthScreen) {
      setAllowBarcodeScan(false);
    } else {
      setAllowBarcodeScan(true);
    }
  }, [showAuthScreen]);

  useEffect(() => {
    persistSaleLocally();
  }, [saleData]);

  useEffect(() => {
    persistSaleLocally();
  }, [customerBean]);

  useEffect(() => {
    loadProductInfoFields();
  }, []);

  useEffect(() => {
    if (showCustomerCrud === true) {
      console.log("hello from show c");
      let callFrom = "trading_screen";
      biRef.child.showCustomerCrudWindow(null, callFrom);
    }
  }, [showCustomerCrud]);

  const translate = t;

  function productSearchClicked() {
    setShowProductSearch(true);
  }

  function persistSaleLocally() {
    if (props.context.storeAdmin.restoreUnfinishedSale && initSaleFlag) {
      let palyload = {
        sale: saleData,
        customerBean: customerBean,
        rawSale: rawSale,
      };
      localStorage.setItem(
        props.saleType + "_runing_sale",
        JSON.stringify(palyload)
      );
    }
  }

  function payOutClicked() {
    biRef.payin.showPaymentTransactionCrudWindow("sale", "payout", null);
  }

  function payInClicked() {
    biRef.payin.showPaymentTransactionCrudWindow("sale", "payin", null);
  }

  function getSideMenu() {
    let m = [];
    if (props.context.appMode === "mobile") {
      m.push({
        key: "history",
        label: getHistoryTitle(props.saleType),
        icon: <HistoryIcon />,
        action: handleShowHistoryClick,
      });
    }

    if (props.saleType === "R_SALE") {
      m.push({
        key: "history",
        label: getHistoryTitle(props.saleType),
        icon: <HistoryIcon />,
        action: handleShowHistoryClick,
      });
    }

    m.push({
      key: "Product_lookup",
      label: translate("Product Lookup"),
      icon: <HistoryIcon />,
      action: productSearchClicked,
    });

    if (props.saleType === "SALE") {
      if (privileges.payout_buttun_allowed) {
        m.push({
          key: "pay_out",
          label: translate("Pay Out"),
          icon: <ArrowUpwardIcon />,
          action: payOutClicked,
          colour: purple[700],
        });
      }
      if (privileges.payin_buttun_allowed) {
        m.push({
          key: "pay_in",
          label: translate("Pay In"),
          icon: <ArrowDownwardIcon />,
          action: payInClicked,
          colour: purple[700],
        });
      }
      if (
        props.context.appType === "POS" ||
        props.context.appType === "M_POS"
      ) {
        m.push({
          key: "sale_order_history",
          label: getHistoryTitle("SALE_ORDER"),
          icon: <SearchIcon />,
          action: handleSaleOrderInSale,
        });
        m.push({
          key: "sale_service_history",
          label: getHistoryTitle("SERVICE"),
          icon: <SearchIcon />,
          action: handleServiceInSale,
        });
      }
    }
    if (props.saleType === "SALE_RETURN") {
      m.push({
        key: "invoice_history",
        label: getHistoryTitle("SALE"),
        icon: <SearchIcon />,
        action: handleInvocieSearchInSaleReturn,
      });
    }
    return m;
  }

  async function loadProductInfoFields() {
    let dbData1 = await db.config.where("name").equals("UNIT_TYPES").toArray();
    setUnitTypeOptions(JSON.parse(dbData1[0].configTxt));

    let dbData2 = await db.config
      .where("name")
      .equals("RESTAURANT_UNIT_TYPES")
      .toArray();
    setRUnitTypeOptions(JSON.parse(dbData2[0].configTxt));

    let dbData = await db.config
      .where("name")
      .equals("PRODUCT_INFO_CUSTOM_FIELDS")
      .toArray();
    if (dbData && dbData.length == 1) {
      setProductInfoFields(JSON.parse(dbData[0].configTxt));
    }
  }

  function handleSaleOrderInSale() {
    setCurrentScreen("saleOrderInSale");
  }

  function handleInvocieSearchInSaleReturn() {
    setCurrentScreen("saleHistoryInReturn");
  }

  function handleServiceInSale() {
    setCurrentScreen("serviceInSale");
  }

  function handleShowHistoryClick() {
    if (props.saleType === "R_SALE") setCurrentScreen("saleHistory1");
    if (props.saleType === "SALE") setCurrentScreen("saleHistory");
    if (props.saleType === "SALE_RETURN") setCurrentScreen("saleReturnHistory");
    if (props.saleType === "SALE_ORDER") setCurrentScreen("saleOrderHistory");
    if (props.saleType === "SERVICE") setCurrentScreen("serviceHistory");
  }

  var biRef = {};
  var biRef2 = {};
  var biRef3 = {};

  useEffect(() => {
    if (props.restaurantSaleType && props.restaurantSaleType.length > 0) {
      setCurrentMenu(props.restaurantSaleType);
    }
  }, [props.restaurantSaleType]);

  useEffect(() => {
    initSaleScreen();
  }, []);

  useEffect(() => {
    if (currentUser && saleSetting) {
      if (saleSetting.showTerminalInfoOnSaleScreen) {
        setClockPrefix(
          "[ " + currentUser + " @ " + props.terminalBean.name + " ]  "
        );
      }
    }
  }, [currentUser, saleSetting]);

  useEffect(() => {
    if (customerBean) {
      if (customerBean.creditCustomer) {
        setPaymentMode("CREDIT");
      } else {
        setPaymentMode("CASH");
      }
    }
  }, [customerBean]);

  useEffect(() => {
    if (
      tableSelectionEventSource === "table_button" &&
      tableInfo &&
      currentMenu === "dineIn" &&
      parentSaleBean
    ) {
      updateSaleStatus(uuid, null, tableInfo);
      setTableSelectionEventSource(null);
    }
  }, [tableInfo]);

  useEffect(() => {
    if (currentMenu && props.context.appType === "R_POS") {
      setEnableKot(true);
      if (currentMenu === "takeAway") {
        takeAwaySync = true;
        setCurrentQueue([]);
        refreshTakeAwayQueue();
      } //
      else if (currentMenu === "delivery") {
        deliverySync = true;
        setCurrentQueue([]);
        refreshDeliveryQueue();
      } else if (currentMenu === "dineIn") {
        dineInSYnc = true;
        setCurrentQueue([]);
        refreshDineInQueue();
      } /* else if (currentMenu === "online") {
        onlineSync = true;
        setCurrentQueue([]);
        refreshOnlineQueue();
      }*/
      voidSale(true);
    }
    return function cleanup() {
      if (currentMenu === "takeAway") {
        takeAwaySync = false;
      } else if (currentMenu === "delivery") {
        deliverySync = false;
      } else if (currentMenu === "dineIn") {
        dineInSYnc = false;
      } /* else if (currentMenu === "online") {
        onlineSync = false;
      }*/
    };
  }, [currentMenu]);

  useEffect(() => {
    if (props.productCache) {
      setCacheLoaded(true);
    }
  }, [props.productCache]);

  useEffect(() => {
    if (props.context.storeAdmin.enableShift) {
      let d = SaleUtils.getShiftSaleSession(props.saleSession);
      if (d.status === "closing") {
        props.shiftClose();
      }
    }
  }, [props.saleSession]);

  async function refreshTakeAwayQueue() {
    while (takeAwaySync) {
      refreshQueue("takeAway");
      await sleep(10000);
    }
  }

  async function refreshDeliveryQueue() {
    while (deliverySync) {
      refreshQueue("delivery");
      await sleep(10000);
    }
  }

  async function refreshDineInQueue() {
    while (dineInSYnc) {
      refreshQueue("dineIn");
      await sleep(10000);
    }
  }

  /*async function refreshOnlineQueue() {
    while (onlineSync) {
      refreshQueue("online");
      await sleep(10000);
    }
  }*/

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function refreshQueue(menuType) {
    if (props.context.appType === "R_POS") {
      let { data } = await API.get(
        "/api/v1/salesession/active_sales/" + menuType
      );
      setCurrentQueue(data);
    }
  }

  async function loadUsers() {
    let { data } = await API.get("/auth/v1/users/list");
    let users = [];
    for (let d of data) {
      users.push({ id: d.id, name: d.name });
    }
    setUserOptions(users);
  }

  function voidSaleWithAlert() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message: translate("Are you sure to void the sale"),
      type: "warning",
      open: true,
      yes: true,
      no: true,
      event_type: "VOID_SALES",
    });
  }

  function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes" && context.event_type === "VOID_SALES") {
      voidSale(false);
    }
  }

  async function voidSale(skipPrint) {
    if (!skipPrint && props.context.saleSetting.voidReceipt) {
      let payload = createPayload();

      biRef.saleDao.print(
        payload,
        "Print",
        "VOID_PRINT_FORMAT",
        null,
        null,
        null,
        true
      );
    }
    setParentType(null);
    setParentSaleBean(null);
    setSrEta(null);
    setSrNumber(null);
    setSrStatus(null);
    setSrAssignee(null);
    setSaleData([]);
    setRawSale([]);
    setEditMode(false);
    setReturnFlag(false);
    setCustomerBean(null);
    setHoldId(null);
    resetCustomFields();
    showOnPoleDisplay(null, null);
    setHoldNote(null);
    setPrivileges(props.context.privileges);
    setCurrentUser(
      Store.parseJwt(
        Store.get(
          props.context.appMode === "mobile"
            ? "m_refreshToken"
            : "w_refreshToken"
        )
      ).sub
    );
    setSelectedQueue({});
    setUuid(null);
    setIntVersion(null);
    setworkflowStatus("NEW");
    setTableInfo([]);
    setSalesManInfo(null);
    setTradingDate(null);
    setTradingScreenPaymentModeSelect(null);
  }

  async function updateSaleStatus(id, status, tables) {
    props.showProgress("Updating");
    try {
      let { data } = await API.post(
        "/api/v1/sale/" + currentMenu + "/" + id + "/updatestatus",
        { status: status, tables: tables }
      );
    } catch (err) {
      console.log(err);
    }
    props.hideProgress();
    if (status == "CANCELLED" || status == "VOID") {
      voidSale(true);
      refreshQueue(currentMenu);
    } else {
      openRestaurantOrder(id);
    }
  }

  function removeItem() {
    if (privileges.remove_buttun_allowed) {
      biRef.saleList.parentEvent("deleteItem");
    }
  }

  function removeItemAgGrid() {
    let currRow = biRef.saleListAg.parentEvent("getCurrentRow");
    if (currRow && currRow.length > 0) {
      if (saleData[currRow[0].rowIndex]) {
        var index = rawSale.findIndex(function (item, i) {
          return item.key === saleData[currRow[0].rowIndex][9].info.key;
        });
        biRef.saleList.parentEvent("removeRawData", index);
      }
    }
  }

  function getAgGridCurrentRow() {
    let currRow = biRef.saleListAg.parentEvent("getCurrentRow");
    if (currRow && currRow.length > 0) {
      if (saleData[currRow[0].rowIndex]) {
        return currRow[0].rowIndex;
      }
    }
    return 0;
  }

  async function showOnPoleDisplay(line1, line2, pSaleSetting) {
    let vSaleSetting = saleSetting;
    if (pSaleSetting) {
      vSaleSetting = pSaleSetting;
    }
    if (line1 == null && line2 == null) {
      if (vSaleSetting) {
        PoleDisplayUtils.showOnPole(
          props.terminalBean,
          vSaleSetting.poleDisplayDefaultMessage1
            ? vSaleSetting.poleDisplayDefaultMessage1
            : "",
          vSaleSetting.poleDisplayDefaultMessage2
            ? vSaleSetting.poleDisplayDefaultMessage2
            : ""
        );
      }
    } else {
      PoleDisplayUtils.showOnPole(props.terminalBean, line1, line2);
    }
  }
  async function resetCustomFields() {
    let dbData = await db.config
      .where("name")
      .equals("SALE_PAYMENT_CUSTOM_FIELDS")
      .toArray();
    if (dbData && dbData.length == 1) {
      setCustomFields(JSON.parse(dbData[0].configTxt));
      setIsCustomFieldRequired(true);
    } else {
      setIsCustomFieldRequired(false);
    }

    let dbData3 = await db.config.where("name").equals("PAY_CODES").toArray();

    if (dbData3 && dbData3.length > 0) {
      setPayCodeConfigs(JSON.parse(dbData3[0].configTxt));
    }
  }

  async function initSaleScreen() {
    showProgress(true, "Getting Ready...");

    setCurrentUser(
      Store.parseJwt(
        Store.get(
          props.context.appMode === "mobile"
            ? "m_refreshToken"
            : "w_refreshToken"
        )
      ).sub
    );
    let dbData2 = await db.setting.where("sKey").equals("sale").toArray();
    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();

    let dbData3 = await db.terminal.toArray();
    let terminals = [];
    for (let t of dbData3) {
      terminals.push({ name: t.name, id: t.id });
    }
    setTerminalOptions(terminals);
    let jStoreAdm = JSON.parse(storeAdminVal[0].sValue);
    setStoreAdminSetting(jStoreAdm);
    if (jStoreAdm.saleListEngine) {
      let json = JSON.parse(jStoreAdm.saleListEngine);
      setSaleListEngine(json.code);
    } else {
      setSaleListEngine("ag-grid");
    }
    let count = 0;
    let menuSet = false;

    if (props.context.appMode == "mobile") {
    } else {
      if (jStoreAdm.rTakeAway) {
        count++;
        if (!menuSet) {
          setCurrentMenu("takeAway");
          menuSet = true;
        }
      }
      if (jStoreAdm.rDineIn) {
        count++;
        if (!menuSet) {
          setCurrentMenu("dineIn");
          menuSet = true;
        }
      }
      if (jStoreAdm.rDelivery) {
        count++;
        if (!menuSet) {
          setCurrentMenu("delivery");
          menuSet = true;
        }
      }
    }
    /*if (jStoreAdm.rOnline) {
      count++;
      if (!menuSet) {
        setCurrentMenu("online");
        menuSet = true;
      }
    }*/
    if (count > 0) {
      setRMenuCount(count);
    }

    setSaleSetting(JSON.parse(dbData2[0].sValue));
    let colors = [
      "#C7F464",
      "#4ECDC4",
      "#FF6B6B",
      "#DDBC56",
      "#C44D58",
      "#EB94F7",
      "#E2618C",
      "#585CC9",
      "#D68340",
      "#16F777",
      "#E2618C",
    ];

    showOnPoleDisplay(null, null, JSON.parse(dbData2[0].sValue));

    setColorPallet(colors);

    let dbData = await db.config
      .where("name")
      .equals("PAYMENT_SETTINGS")
      .toArray();

    setPaymentSettings(JSON.parse(dbData[0].configTxt));

    await resetCustomFields();
    await loadUsers();
    await loadEmployeesInfo();
    await initSequence();

    if (props.context.storeAdmin.restoreUnfinishedSale) {
      if (props.saleType == "SALE" || props.saleType == "SALE_RETURN") {
        let lclData = localStorage.getItem(props.saleType + "_runing_sale");
        if (lclData) {
          lclData = JSON.parse(lclData);
          if (lclData.sale && lclData.sale.length > 0) {
            setSaleData(lclData.sale);
            setCustomerBean(lclData.customerBean);
            setRawSale(lclData.rawSale);
          }
        }
      }
    }

    setIntiSaleFlag(true);

    showProgress(false);
  }

  async function initSequence() {
    try {
      let result = await API.get(
        "/api/v1/sequence/terminal/" +
          props.terminalBean.id +
          "/" +
          getSequeceKey()
      );

      if (result.data.value) {
        setNextInvoiceNo(parseInt(result.data.value) + 1);
      }
    } catch (err) {
      if (err.response && err.response.status == 404) {
        setNextInvoiceNo(1);
      } else {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate(
            "Not able to get Invoice Sequence From Server, Please contact Support"
          ),
        });
        props.setCurrentPage("home");
      }
    }
  }

  function getSequeceKey() {
    if (props.saleType === "SALE") {
      return "INVOICE" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.saleType === "SALE_RETURN") {
      return "RETURN_INVOICE" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.saleType === "SERVICE") {
      return "SERVICE" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.saleType === "SALE_ORDER") {
      return "SALE_ORDER" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.context.saleType === "R_SALE") {
      if (props.currentMenu === "dineIn") return "R_SALE_DINING";
      if (props.currentMenu === "takeAway") return "R_SALE_TAKE_AWAY";
      if (props.currentMenu === "delivery") return "R_SALE_DELIVERY";
      if (props.currentMenu === "online") return "R_SALE_ONLINE";
    }
    return "";
  }

  async function loadEmployeesInfo() {
    let { data } = await API.get("/api/v1/allemployees");
    let v = [];
    let v2 = [];
    for (let d of data) {
      if (d.empTypes.includes("delivery")) {
        d.selectd = false;
        v.push(d);
      }
      if (d.empTypes.includes("salesman")) {
        d.selectd = false;
        v2.push({ label: d.name, value: d });
      }
    }
    setDeliveryPersons(v);
    setSalesMans(v2);
  }

  function rejectdBarcode(barcode) {
    if (barcode.length == 1 && barcode.charCodeAt(0) == 13) {
      if (biRef.digitPanel)
        biRef.digitPanel.parentEvent("onKeyPressed", "Enter");
    } else {
      if (biRef.digitPanel)
        biRef.digitPanel.parentEvent("onKeyPressed", barcode);
    }
  }
  function onAddProduct(productBean, pricingBean, rowId) {
    biRef.saleList.parentEvent("onAddProduct", productBean, pricingBean, rowId);
  }

  async function onSave(flag, isHold, buttonIndex) {
    biRef.saleDao.onSave(flag, false, true, null, buttonIndex);
  }

  async function onRPOSSave(flag, isHold, buttonIndex) {
    await biRef3.saleDao.onSave(flag, false, true, null, buttonIndex);
    await refreshQueue(currentMenu);
  }

  async function createBill(flag) {
    await biRef.saleDao.onSave("Print", false, false, "BILL CREATED");
  }

  async function onHold(flag) {
    if (saleData.length == 0) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Please add some items"),
      });
    } else {
      biRef2.saleDao.onSave(flag, true, false);
    }
  }

  function onBarcodeScanned(barcode) {
    if (allowBarcodeScan) {
      biRef.saleList.parentEvent("onBarcodeScanned", barcode);
    }
  }

  function updateSaleData(data) {
    setSaleData(data);
  }

  async function createPayload(isHold, ensureNewuuid, newStatus) {
    let payload = Object.create(null);

    if (!editMode) {
      if (!uuid || ensureNewuuid) {
        let idVal = uuidv4();
        if (storeAdminSetting.terminalWiseInvoicing) {
          payload["id"] = idVal;
        }
      }
    } else {
      payload["id"] = uuid;
      payload["intVersion"] = intVersion;
      payload["invoiceNo"] = invoiceNumber;
    }

    payload["saleSessionId"] = props.saleSession.id;
    payload["shiftSessionId"] = SaleUtils.getShiftSaleSessionId(
      props.saleSession
    );

    payload["status"] = "FINAL";
    payload["customerId"] = customerBean ? customerBean.id : null;
    payload["holdId"] = null;
    if (biRef.paymentWindow != undefined)
      biRef.paymentWindow.parentEvent("updatePayload", payload);

    payload["parentInvoiceNumber"] = parentSaleBean
      ? parentSaleBean.invoiceNo
      : null;
    payload["parentSaleId"] = parentSaleBean ? parentSaleBean.id : null;
    payload["parentType"] = parentSaleBean ? parentSaleBean.className : null;

    if (props.saleType === "SALE_ORDER") {
      payload["saleOrderStatus"] = "CREATED";
    }

    if (props.saleType === "R_SALE") {
      if (newStatus) {
        payload["workflowStatus"] = newStatus;
      } else {
        if (workflowStatus && workflowStatus != "NEW") {
          payload["workflowStatus"] = workflowStatus;
        } else {
          payload["workflowStatus"] = "CREATED";
        }
      }
      payload["enableKot"] = enableKot;
      if (parentSaleBean && parentSaleBean.token) {
        payload["token"] = parentSaleBean.token;
      }
    }

    if (props.saleType === "SERVICE") {
      if (srStatus) {
        payload["serviceStatus"] = srStatus.id;
      } else {
        payload["serviceStatus"] = "OPEN";
      }
      if (srAssignee) payload["assigned"] = srAssignee.name;
      if (srEta) payload["deliveryDate"] = StringUtils.getIsoDate(srEta);
    }
    applySaleSummary(payload);

    if (
      props.terminalBean.saleMode === "KEYBOARD_TRADING" &&
      props.saleType != "SERVICE"
    ) {
      let payCodes = [];
      payCodes.push({
        payCode: paymentMode,
        tendered: payload.totalAmount,
        amount: payload.totalAmount,
        balance: 0,
      });
      payload["salePaymentBeanList"] = payCodes;
    }

    await updateSaleItem(payload);
    if (tradingDate) {
      if (typeof tradingDate == "string") {
        payload["date"] = tradingDate;
      } else {
        payload["date"] = tradingDate.toISOString();
      }
    } else {
      payload["date"] = new Date().toISOString();
    }

    customFields.map((item) => {
      payload[item.key] = item.value;
    });

    customFields.map((item) => {
      payload[item.key] = item.value;
    });

    payload["saleData"] = JSON.stringify(saleData);
    payload["rawData"] = JSON.stringify(rawSale);

    if (isHold) {
      payload["holdNote"] = holdNote;
      payload["customerId"] = customerBeanForHold
        ? customerBeanForHold.value.id
        : null;
    }
    payload["terminalId"] = props.terminalBean.id;
    payload["tables"] = tableInfo;
    payload["salesManInfo"] = salesManInfo;
    if (tradingScreenPaymentModeSelect != null) {
      payload["paymentMode"] = tradingScreenPaymentModeSelect.name;
    }

    return payload;
  }

  function applySaleSummary(payload) {
    let subTotal = getubTotalDisc(payload);
    let total = 0;
    let noItems = 0;
    let qty = 0;
    let qtyInBaseUnit = 0;
    let tax = 0;
    let discount = 0;
    let amountExTax = 0;
    let itemsSet = new Set();
    let selectedRow = null;

    for (let d of saleData) {
      if (d[9].info.selected == true) {
        selectedRow = d;
      }
      if (!d[9].info.returnFlag) {
        itemsSet.add(d[9].info.key);
        qty = qty + parseFloat(d[5].v);
        qtyInBaseUnit =
          qtyInBaseUnit +
          parseFloat(d[5].v) * parseFloat(d[9].info.pricingBean.factor);
      }

      total = total + parseFloat(d[8].v);

      tax = tax + parseFloat(d[7].v);
      discount = discount + parseFloat(d[9].info.discountAmount);
    }

    payload["numberOfItems"] = itemsSet.size;
    payload["totalQuantity"] = PricingUtils.formattedNumber(
      qtyInBaseUnit,
      props.context.store.currencyDecimal
    );

    payload["totalAmount"] = PricingUtils.formatPriceAfterRounding(
      total - subTotal,
      props.context.store.currencyDecimal,
      saleSetting ? saleSetting.enableRoundoffSaleAmount : null,
      saleSetting ? saleSetting.roundOffFactor : null
    );

    payload["totalAmountWithoutRoundoff"] = PricingUtils.formattedNumber(
      parseFloat(
        PricingUtils.formattedNumber(total, props.context.store.currencyDecimal)
      ) - subTotal,
      props.context.store.currencyDecimal
    );

    payload["totalRoundoffAmount"] =
      payload["totalAmount"] - payload["totalAmountWithoutRoundoff"];

    payload["totalItemDiscount"] = PricingUtils.formattedNumber(
      discount,
      props.context.store.currencyDecimal
    );

    payload["totalExTax"] = amountExTax;
    payload["taxAmount"] = tax;

    payload["subTotalDiscount"] = PricingUtils.formattedNumber(
      subTotal,
      props.context.store.currencyDecimal
    );

    payload["totalSavedAmount"] = PricingUtils.formattedNumber(
      parseFloat(payload["subTotalDiscount"]) +
        parseFloat(payload["totalItemDiscount"]),
      props.context.store.currencyDecimal
    );
  }

  function getubTotalDisc(payload) {
    if (payload.salePaymentBeanList) {
      for (let payment of payload.salePaymentBeanList) {
        if (payment.payCode === "DISCOUNT") {
          return parseFloat(payment.amount);
        }
      }
    }
    return 0;
  }

  async function updateSaleItem(payload) {
    let saleItems = [];

    let subTotal = getubTotalDisc(payload);
    let lclSale = [...saleData];

    await SaleUtils.distributeDiscount(
      lclSale,
      subTotal,
      props.context.store.currencyDecimal
    );

    let totTaxAmount = 0;
    let uiTotalAmount = 0;
    let uiTotalAmountExTax = 0;
    for (const row of saleData) {
      let item = {};
      item["productId"] = row[9].info.productBean.id;
      item["barcode"] =
        row[9].info.productBean.productPricingBeanList[0].productBarcodeBeanList
          .length > 0
          ? row[9].info.productBean.productPricingBeanList[0]
              .productBarcodeBeanList[0].barcode
          : "";
      item["itemCode"] = row[9].info.productBean.code;
      item["localName"] = row[9].info.productBean.localName;
      item["pricingUnitType"] = row[4].v;
      item["unitFactor"] = row[9].info.pricingBean.factor;

      item["retailSalePrice"] = row[9].info.retailSalePrice;
      item["productName"] = row[2].v;
      item["quantity"] = row[5].v;

      item["origPrice"] = row[9].info.origPrice;
      item["cost"] = row[9].info.cost;
      item["netCost"] = row[9].info.netCost;

      //Real Data

      item["price"] = row[9].info.finalPrice;
      item["margin"] = row[9].info.finalMargin;
      item["netMargin"] = row[9].info.finalNetMargin;
      item["netAmount"] = row[9].info.finalNetAmount;
      item["netTaxAmount"] = row[9].info.finalNetTaxAmount;
      item["promotionPercentage"] = row[9].info.finalPromotionPercentage;
      item["promotionAmount"] = row[9].info.finalPromotionAmount;
      item["netAmountExTax"] = PricingUtils.formattedNumber(
        parseFloat(item["netAmount"]) - parseFloat(item["netTaxAmount"]),
        props.context.store.currencyDecimal
      );

      totTaxAmount = totTaxAmount + parseFloat(item["netTaxAmount"]);

      //UI

      item["uiPrice"] = row[9].info.price;
      item["uiMargin"] = row[9].info.margin;
      item["uiNetMargin"] = row[9].info.netMargin;
      item["uiNetAmount"] = row[8].v;
      item["uiNetTaxAmount"] = row[7].v;
      item["uiPromotionPercentage"] = row[6].v;
      item["uiPromotionAmount"] = row[9].info.discountAmount;
      item["uiNetAmountExTax"] = PricingUtils.formattedNumber(
        parseFloat(item["uiNetAmount"]) - parseFloat(item["uiNetTaxAmount"]),
        props.context.store.currencyDecimal
      );

      uiTotalAmount = uiTotalAmount + parseFloat(item["uiNetAmount"]);
      uiTotalAmountExTax =
        uiTotalAmountExTax + parseFloat(item["uiNetAmountExTax"]);

      //END

      item["isReturn"] = row[9].info.returnFlag;
      item["saleItemNote"] = row[9].info.saleItemNote
        ? row[9].info.saleItemNote
        : "";
      item["productInfoField1"] = row[9].info.productInfoField1;
      item["productInfoField2"] = row[9].info.productInfoField2;
      item["productInfoField3"] = row[9].info.productInfoField3;
      item["productInfoField4"] = row[9].info.productInfoField4;
      item["productInfoField5"] = row[9].info.productInfoField5;
      item["productInfoField6"] = row[9].info.productInfoField6;

      item["isKit"] = row[9].info.productBean.isKit;
      item["isStockItem"] = row[9].info.productBean.isStockItem;

      if (row[9].info.productBean.productType == "S") {
        item["isService"] = true;
        item["serviceItemName"] = row[9].info.serviceMeta.itemName;
        item["serviceItemSerialNo"] = row[9].info.serviceMeta.serialNo;
        item["serviceItemTypes"] = getServiceDetails(
          row[9].info.serviceMeta.itemTypes
        );
        item["serviceItemNotes"] = row[9].info.serviceMeta.itemNotes;
        item["serviceComplaints"] = getServiceDetails(
          row[9].info.serviceMeta.complaints
        );
        item["serviceComplaintNotes"] = row[9].info.serviceMeta.complaintNotes;
      } else {
        item["isService"] = false;
      }
      saleItems.push(item);
    }
    payload["saleItemBeanList"] = saleItems;

    payload["taxAmount"] = PricingUtils.formattedNumber(
      totTaxAmount,
      props.context.store.currencyDecimal
    );
    payload["totalExTax"] = PricingUtils.formattedNumber(
      parseFloat(payload["totalAmount"]) - totTaxAmount,
      props.context.store.currencyDecimal
    );

    payload["totalUiNetAmount"] = PricingUtils.formattedNumber(
      uiTotalAmount,
      props.context.store.currencyDecimal
    );

    payload["totalUiNetAmountExTax"] = PricingUtils.formattedNumber(
      uiTotalAmountExTax,
      props.context.store.currencyDecimal
    );
  }

  function getServiceDetails(arr) {
    let s = "";
    let comma = "";
    for (let a of arr) {
      if (a.selected) {
        s = s + comma + a.value;
        comma = ",";
      }
    }
    return s;
  }

  function getubTotalDisc(payload) {
    if (payload.salePaymentBeanList) {
      for (let payment of payload.salePaymentBeanList) {
        if (payment.payCode === "DISCOUNT") {
          return parseFloat(payment.amount);
        }
      }
    }
    return 0;
  }

  function paymentEvent(event) {
    if (biRef.paymentWindow != undefined)
      biRef.paymentWindow.parentEvent(event);
  }

  function showPaymentWindow() {
    if (currentMenu === "dineIn") {
      if (!tableInfo || tableInfo.length == 0) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Please Select Table"),
        });
        return;
      }
    }

    let flag = false;
    if (props.saleType == "SERVICE" || props.saleType == "SALE_ORDER") {
      if (customerBean == null) {
        props.setAlert({
          show: true,
          title: "Alert!",
          message: translate(
            "Please select customer before proceed with payment"
          ),
        });
        return;
      }
    }
    if (
      saleSetting.allowSalePaymentWithoutCustomer == undefined ||
      saleSetting.allowSalePaymentWithoutCustomer == null ||
      saleSetting.allowSalePaymentWithoutCustomer == true
    ) {
      flag = true;
    } else {
      if (customerBean == null) {
        props.setAlert({
          show: true,
          title: "Alert!",
          message: translate("Please select customer before proceed payment"),
        });
        flag = false;
        return;
      } else {
        flag = true;
      }
    }
    if (flag) {
      if (saleData.length == 0) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Please add some items"),
        });
      } else {
        if (props.context.appMode === "mobile") {
          if (isCustomFieldRequired) {
            setCurrentScreen("custom_fields");
          } else {
            setCurrentScreen("payment");
          }
        }
        if (props.context.appMode === "desktop-pos") {
          setShowPaymentScreen(true);
        }
      }
    }
  }

  function handleSelectSale(saleBean, parentSaleType, resetDate, eMode) {
    if (saleBean) {
      if (saleBean.rawData) {
        setSaleData(JSON.parse(saleBean.saleData));
        setRawSale(JSON.parse(saleBean.rawData));
      } else {
        populateItems(saleBean);
      }
      if (saleBean.customerBean) {
        setCustomerBean(saleBean.customerBean);
      }
      if (resetDate) {
        setTradingDate(new Date());
      } else {
        setTradingDate(saleBean.date);
      }
      setCustomerBeanForHold(null);
      setParentSaleBean(saleBean);
      setParentType(parentSaleType);
      if (eMode) {
        setIntVersion(saleBean.intVersion);
        setInvoiceNumber(saleBean.invoiceNo);
        setEditMode(true);
        setUuid(saleBean.id);
      }
    }
    setCurrentScreen("sale");
  }

  async function openRestaurantOrder(id) {
    props.showProgress("Opening Order...");
    try {
      let { data } = await API.get("/api/v1/sale/" + currentMenu + "/" + id);

      handleSelectService(data, props.saleType);
    } catch (err) {}
    props.hideProgress();
  }

  function handleSelectService(srBean, parentSaleType) {
    setUuid(srBean.id);
    setIntVersion(srBean.intVersion);

    setInvoiceNumber(srBean.invoiceNo);
    setSrNumber(srBean.invoiceNo);
    setSrEta(srBean.deliveryDate);

    setSrStatus(SaleUtils.getOption(statusOptions, srBean.serviceStatus));
    setSrAssignee(SaleUtils.getOption3(userOptions, srBean.assigned));

    setParentType(parentSaleType);
    setParentSaleBean(srBean);
    setCustomerBeanForHold(null);

    if (srBean.customerBean) {
      setCustomerBean(srBean.customerBean);
    } else {
      setCustomerBean(null);
    }

    setSaleData(JSON.parse(srBean.saleData));
    setRawSale(JSON.parse(srBean.rawData));
    setTradingDate(parseISOString(srBean.date));

    setCurrentScreen("sale");
    setworkflowStatus(srBean.workflowStatus);
    setTableInfo(srBean.tables);
    if (srBean.salesManInfo) {
      setSalesManInfo(srBean.salesManInfo);
    }
  }

  function parseISOString(s) {
    var b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  function createInvoiceFromSaleOrder(saleOrderBean) {
    if (saleOrderBean) {
      setSaleData(JSON.parse(saleOrderBean.saleData));
      setRawSale(JSON.parse(saleOrderBean.rawData));
      setParentType(saleOrderBean.className);
      setParentSaleBean(saleOrderBean);
      setTradingDate(null);
      if (saleOrderBean.customerBean) {
        setCustomerBean(saleOrderBean.customerBean);
      }
      setCurrentScreen("sale");
    }
  }

  function createInvoiceFromService(srBean) {
    if (srBean) {
      setParentSaleBean(srBean);
      setParentType(srBean.className);
      setSaleData(JSON.parse(srBean.saleData));
      setRawSale(JSON.parse(srBean.rawData));
      setTradingDate(null);
      if (srBean.customerBean) {
        setCustomerBean(srBean.customerBean);
      }
    }
    setCurrentScreen("sale");
  }

  async function populateItems(saleBean) {
    let rawData = [];
    for (let i = 0; i < saleBean.saleItemBeanList.length; i++) {
      let item = saleBean.saleItemBeanList[i];
      let key = deriveKey(
        item.productId,
        item.pricingUnitType,
        item.isReturn,
        "DELI" + ((saleData ? saleData.length : 0) + 1)
      );

      let pricingBean = getPricingFromUnitType(
        item.productBean,
        item.pricingUnitType
      );
      let productBean = item.productBean;
      let price = item.origPrice;
      let qty = item.quantity;
      let returnFlag = false;
      // let key = key;
      let extax = null;

      if (pricingBean) {
        if (
          productBean.kitItems != null &&
          productBean.kitItems != undefined &&
          productBean.isKit != null &&
          productBean.isKit != undefined &&
          productBean.isExpandKitDuringSale != null &&
          productBean.isExpandKitDuringSale != undefined &&
          productBean.isExpandKitDuringSale == true
        ) {
          for (let i = 0; i < productBean.kitItems.length; i++) {
            let dbData = await db.product
              .where("id")
              .equals(productBean.kitItems[i].productId)
              .toArray();
            if (dbData[0] != null && dbData[0] != undefined) {
              let key = deriveKey(
                dbData[0].id,
                dbData[0].productPricingBeanList[0].unitType,
                returnFlag
              );
              let position = isProductExist(key);
              if (position >= 0) {
                let result = await SaleUtils.updateProduct(
                  position,
                  "addQty",
                  parseFloat(productBean.kitItems[i].quantity),
                  rawSale,
                  saleData,
                  props.context,
                  props.setAlert,
                  translate
                );
                if (result) {
                  setRawSale(result.rawData);
                  updateSaleData(result.rawData, result.key);
                }
              } else {
                let d = {
                  index: rawData.length,
                  productBean: dbData[0],
                  pricingBean: dbData[0].productPricingBeanList[0],
                  price: dbData[0].productPricingBeanList[0].price,
                  qty: parseFloat(productBean.kitItems[i].quantity),
                  returnFlag: returnFlag,
                  discountFlag: returnFlag ? false : productBean.isDiscounted,
                  key: key,
                  exTax: extax,
                  saleItemNote: "",
                };
                rawData.push(d);
              }
            }
          }
        } else {
          let d = {
            index: rawData.length,
            productBean: productBean,
            pricingBean: pricingBean,
            price: price,
            qty: qty,
            returnFlag: returnFlag,
            discountFlag: returnFlag ? false : productBean.isDiscounted,
            key: key,
            exTax: extax,
            saleItemNote: "",
          };
          if (item.promotionPercentage > 0) {
            d.customPrice = null;
            d.customDiscountPer = null;
            d.customDiscountAmount = price - parseFloat(item.retailSalePrice);
          }
          rawData.push(d);
        }
      } else {
        console.log("PRICING BEAN NOT FOUND!");
      }
    }
    setRawSale(rawData);
    rawData.map((item) => {
      updateSaleDetails(rawData, item.key);
    });
  }

  function getPricingFromUnitType(productBean, unitType) {
    for (let pricing of productBean.productPricingBeanList) {
      if (pricing.unitType === unitType) {
        return pricing;
      }
    }
    return null;
  }

  function deriveKey(productId, pricingUnitType, returnFlag, suffix) {
    let key =
      productId +
      "-" +
      pricingUnitType +
      (returnFlag ? "-return-" + (saleData ? saleData.length : 0) + 1 : "") +
      (suffix ? suffix : "");
    return key;
  }

  async function updateSaleDetails(data, key) {
    let saleData = await SaleUtils.updateSaleData(
      data,
      key,
      props.context.store.currencyDecimal,
      colorPallet,
      setReturnFlag,
      props.context
    );
    updateSaleData(saleData[0]);
    setReturnFlag(false);
  }

  function isProductExist(key) {
    var data = [...rawSale];
    let i = 0;
    for (let d of data) {
      if (d.key === key) {
        return i;
      }
      i++;
    }
    return -1;
  }

  function handlePrintSale(saleBean) {
    console.log(saleBean.id);
  }

  function onNoteAdded(value) {
    setCurrentScreen("sale");

    let position = SaleUtils.getCurrentRow(saleData);
    if (position >= 0) {
      var data = [...saleData];
      data[position][9].info.saleItemNote = value;
      setSaleData(data);
      let rowSale = [...rawSale];
      rowSale[
        SaleUtils.findRowSaleIndexByKey(rowSale, data[position][9].info.key)
      ].saleItemNote = value;
      setRawSale(rowSale);
    }
    setValue("");
  }

  function onNoteAddedAgGrid(value) {
    setCurrentScreen("sale");

    let position = getAgGridCurrentRow();
    if (position >= 0) {
      var data = [...saleData];
      data[position][9].info.saleItemNote = value;
      setSaleData(data);
      let rowSale = [...rawSale];
      rowSale[
        SaleUtils.findRowSaleIndexByKey(rowSale, data[position][9].info.key)
      ].saleItemNote = value;
      setRawSale(rowSale);
    }
    setValue("");
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onChangeValueEvent(value, type, pos) {
    setCurrentScreen("sale");

    if (type === "updateQty") {
      if (value == "0" || parseFloat(value) == 0) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Zero Quantity not allowed"),
        });
        return;
      }
    }

    if (value != null && value != "") {
      let position;
      if (pos == undefined) {
        position = SaleUtils.getCurrentRow(saleData);
      } else {
        position = pos;
      }
      if (position >= 0) {
        let result = await SaleUtils.updateProduct(
          position,
          type,
          value,
          rawSale,
          saleData,
          props.context,
          props.setAlert,
          translate
        );

        if (result) {
          setRawSale(result.rawData);
          SaleUtils.updateSaleData(
            result.rawData,
            result.key,
            props.context.store.currencyDecimal,
            colorPallet,
            setReturnFlag,
            props.context
          );

          let res = await SaleUtils.updateSaleData(
            result.rawData,
            result.key,
            props.context.store.currencyDecimal,
            colorPallet,
            setReturnFlag,
            props.context
          );

          setSaleData(res[0]);
          setReturnFlag(false);
        }
      }
    }
  }

  function onChangeQtyAndPrice(qty, price) {
    //console.log("1>>>");
    SaleUtils.addProductNew(
      rawSale,
      setRawSale,
      setSaleData,
      colorPallet,
      props.context,
      productBean,
      pricingBean,
      price,
      qty,
      false,
      productKey,
      false,
      null,
      setReturnFlag
    );
    setCurrentScreen("sale");
  }

  function setAllowBarcodeScanFunc(value) {
    if (value) {
      divRef.current.focus();
    }
    setAllowBarcodeScan(value);
  }

  function onChangePrice(price) {
    SaleUtils.addProductNew(
      rawSale,
      setRawSale,
      setSaleData,
      colorPallet,
      props.context,
      productBean,
      pricingBean,
      price,
      1,
      returnFlag,
      productKey,
      false,
      null,
      setReturnFlag
    );
    setCurrentScreen("sale");
  }

  async function persistSale(printFlag, drawerFlag) {
    if (currentMenu === "dineIn") {
      if (!tableInfo || tableInfo.length == 0) {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("Please Select Table"),
        });
        return;
      }
    }
    if (saleData.length == 0) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Please add some items"),
      });
      return;
    }

    if (props.context.appType === "POS" || props.context.appType === "M_POS") {
      if (customerBean == null) {
        props.setAlert({
          show: true,
          title: "Alert!",
          message: translate(
            "Please select customer before creating " +
              getAlertTitle(props.saleType) +
              " Request"
          ),
        });
      } else if (
        (tradingScreenPaymentModeSelect === null ||
          tradingScreenPaymentModeSelect === "") &&
        props.terminalBean.saleMode === "KEYBOARD_TRADING"
      ) {
        props.setAlert({
          show: true,
          title: "Alert!",
          message: translate(
            "Please select payment method before creating " +
              getAlertTitle(props.saleType) +
              " Request"
          ),
        });
      } else {
        biRef.saleDao.onSave(printFlag ? "Print" : "Save", false);
        if (drawerFlag) {
          PrintUtils.openDrawer(props.terminalBean, props.setAlert, translate);
        }
      }
    }

    if (props.context.appType === "R_POS") {
      if (currentMenu === "delivery" || currentMenu === "online") {
        if (customerBean == null) {
          props.setAlert({
            show: true,
            title: "Alert!",
            message: translate(
              "Please select customer before creating " +
                getAlertTitle(props.saleType) +
                " Request"
            ),
          });
          return;
        }
      }
      await biRef.saleDao.onSave(printFlag ? "Print" : "Save", false);
      if (drawerFlag) {
        PrintUtils.openDrawer(props.terminalBean, props.setAlert, translate);
      }
    }
  }

  function handleLoginSucessResponse(authToken) {
    if (
      window.JSBridge &&
      typeof window.JSBridge !== "undefined" &&
      window.JSBridge !== null
    ) {
      let baseUrl = window.JSBridge.getBaseURL();
      getPrivileges(baseUrl, authToken);
    } else {
      getPrivileges("", authToken);
    }
  }

  async function getPrivileges(baseUrl, authToken) {
    try {
      const response = await fetch(baseUrl + "/auth/v1/users/myPrivileges", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.status === 200) {
        const json = await response.json();
        if (setPrivileges) {
          setPrivileges(json);
          setCurrentUser(Store.parseJwt(authToken).sub);
        }
      }
    } catch (e) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
    }
  }

  const mobileContent = (
    <div>
      {props.saleType === "SERVICE" && (
        <MServiceSummary
          data={saleData}
          context={props.context}
          biRef={biRef}
          mobile={true}
          saleSetting={saleSetting}
          setCurrentScreen={setCurrentScreen}
          srNumber={srNumber}
          srAssignee={srAssignee}
          setSrAssignee={setSrAssignee}
          setSrNumber={setSrNumber}
          srAssigneeLabel={srAssigneeLabel}
          userOptions={userOptions}
          srEta={srEta}
          setSrEta={setSrEta}
          srStatus={srStatus}
          setSrStatus={setSrStatus}
          statusOptions={statusOptions}
        ></MServiceSummary>
      )}
      <SearchBar
        onAddProduct={onAddProduct}
        prompt={
          props.saleType != "SERVICE"
            ? "Search for Service or Product"
            : translate("Search or Scan the product")
        }
        productCache={props.productCache}
        productCache2={props.productCache2}
        handleKeyPress={handleKeyPress}
        context={props.context}
      ></SearchBar>
      <SaleList
        data={saleData}
        rawData={rawSale}
        setRawSale={setRawSale}
        biRef={biRef}
        setSaleData={setSaleData}
        setAlert={props.setAlert}
        showMessage={props.showMessage}
        context={props.context}
        returnFlag={returnFlag}
        changeReturnFlag={setReturnFlag}
        colorPallet={colorPallet}
        mobile={true}
        saleSetting={saleSetting}
        // selectedSaleItemIndex={selectedSaleItemIndex}
        // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
        setValue={setValue}
        setCurrentScreen={setCurrentScreen}
        saleType={props.saleType}
        pricingBean={pricingBean}
        productBean={productBean}
        setProductBean={setProductBean}
        setPricingBean={setPricingBean}
        setServiceDataMode={setServiceDataMode}
        serviceDataMode={serviceDataMode}
        setCurrentRow={setCurrentRow}
        currentRow={currentRow}
        privileges={privileges}
        terminalBean={props.terminalBean}
        workflowStatus={workflowStatus}
        onChangeValueEvent={onChangeValueEvent}
        setProductKey={setProductKey}
      ></SaleList>

      <SaleSummary
        data={saleData}
        context={props.context}
        biRef={biRef}
        mobile={true}
        saleSetting={saleSetting}
        saleType={props.saleType}
        terminalBean={props.terminalBean}
      ></SaleSummary>

      <Grid container>
        <Grid item xs={props.saleType === "SERVICE" ? 12 : 6}>
          <div style={{ marginRight: props.saleType === "SERVICE" ? 0 : 5 }}>
            {customerBean != null && (
              <ActionButtonOrangeSmallFont
                onClick={() => {
                  setCurrentScreen("customer_search");
                }}
              >
                {customerBean != null ? customerBean.name : "CUSTOMER"}
              </ActionButtonOrangeSmallFont>
            )}

            {customerBean == null && (
              <ActionButtonOrange
                onClick={() => {
                  setCurrentScreen("customer_search");
                }}
              >
                {customerBean != null ? customerBean.name : "CUSTOMER"}
              </ActionButtonOrange>
            )}
          </div>
        </Grid>
        {props.saleType != "SERVICE" && (
          <Grid item xs={6}>
            <div style={{ marginleft: 5 }}>
              <PaymentButton
                onClick={() => {
                  showPaymentWindow(true);
                }}
              >
                {props.saleType == "SALE_ORDER"
                  ? translate("Place Order")
                  : props.saleType == "SERVICE"
                  ? translate("Proceed")
                  : translate("Payment")}
              </PaymentButton>
            </div>
          </Grid>
        )}
        {props.saleType === "SERVICE" && (
          <Grid item xs={6}>
            <div style={{ marginRight: 2, marginTop: 3 }}>
              <PaymentButton
                onClick={() => {
                  persistSale(false);
                }}
              >
                {translate("Save")}
              </PaymentButton>
            </div>
          </Grid>
        )}
        {props.saleType === "SERVICE" && (
          <Grid item xs={6}>
            <div style={{ marginLeft: 2, marginTop: 3 }}>
              <PaymentButton
                onClick={() => {
                  persistSale(true);
                }}
              >
                {translate("Save & Print")}
              </PaymentButton>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );

  function getTableLabel() {
    if (!tableInfo || tableInfo.length == 0) {
      return "Table";
    }
    let label = "Table";
    if (tableInfo.length > 0) {
      label = label + " ";
      let comma = "";
      for (let table of tableInfo) {
        label = label + comma + table.tableName;
        comma = ",";
      }
    }
    return label;
  }

  const r_pos_mobile_content = (
    <div>
      <Grid container>
        <Grid xs={6} sx={{ padding: "2px" }}>
          <ActionButton
            sx={{
              height: "60px",
              backgroundColor: teal[500],
              "&:hover": {
                backgroundColor: teal[700],
              },
              color: "white",
            }}
            onClick={() => {
              //setSelectedQueue(item);
              setCurrentScreen("dineIn_item_select");
            }}
          >
            Add Item
          </ActionButton>
        </Grid>
        <Grid xs={6} sx={{ padding: "2px" }}>
          <ActionButton
            sx={{
              height: "60px",
              backgroundColor: "teal",
              "&:hover": {
                backgroundColor: teal[700],
              },
              color: "white",
            }}
            onClick={() => {
              //setSelectedQueue(item);
              setTableSelectionEventSource("table_button");
              setCurrentScreen("dineIn_table_select");
            }}
          >
            {getTableLabel()}
          </ActionButton>
        </Grid>
      </Grid>{" "}
      <SearchBar
        onAddProduct={onAddProduct}
        prompt={
          props.saleType != "SERVICE"
            ? "Search for Items"
            : translate("Search or Items")
        }
        productCache={props.productCache}
        productCache2={props.productCache2}
        handleKeyPress={handleKeyPress}
        context={props.context}
      ></SearchBar>
      <SaleList
        data={saleData}
        rawData={rawSale}
        setRawSale={setRawSale}
        biRef={biRef}
        setSaleData={setSaleData}
        setAlert={props.setAlert}
        showMessage={props.showMessage}
        context={props.context}
        returnFlag={returnFlag}
        changeReturnFlag={setReturnFlag}
        colorPallet={colorPallet}
        mobile={true}
        saleSetting={saleSetting}
        // selectedSaleItemIndex={selectedSaleItemIndex}
        // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
        setValue={setValue}
        setCurrentScreen={setCurrentScreen}
        saleType={props.saleType}
        pricingBean={pricingBean}
        productBean={productBean}
        setProductBean={setProductBean}
        setPricingBean={setPricingBean}
        setServiceDataMode={setServiceDataMode}
        serviceDataMode={serviceDataMode}
        setCurrentRow={setCurrentRow}
        currentRow={currentRow}
        privileges={privileges}
        terminalBean={props.terminalBean}
        workflowStatus={workflowStatus}
        onChangeValueEvent={onChangeValueEvent}
        setProductKey={setProductKey}
      ></SaleList>
      <SaleSummary
        data={saleData}
        context={props.context}
        biRef={biRef}
        mobile={true}
        saleSetting={saleSetting}
        saleType={props.saleType}
        terminalBean={props.terminalBean}
      ></SaleSummary>
      <Grid container>
        {/*<Grid item xs={12}>
          <div>
            <ActionButtonOrange
              style={{ fontSize: "1rem" }}
              onClick={() => {
                setCurrentScreen("customer_search");
              }}
            >
              {customerBean != null ? customerBean.name : "CUSTOMER"}
            </ActionButtonOrange>
          </div>
            </Grid>*/}
        <Grid item xs={currentMenu == "dineIn" ? 6 : 12}>
          <div style={{ paddingTop: "4px", paddingRight: "2px" }}>
            <PaymentButton
              style={{ fontSize: "1rem", height: "60px" }}
              onClick={() => {
                persistSale(true);
              }}
            >
              {workflowStatus === "NEW"
                ? translate("Create Order")
                : translate("Update Order")}
            </PaymentButton>
          </div>
        </Grid>
        {currentMenu == "dineIn" && (
          <Grid item xs={6}>
            <div style={{ paddingTop: "4px", paddingRight: "2px" }}>
              <PaymentButton
                style={{ fontSize: "1rem", height: "60px" }}
                onClick={() => {
                  createBill(true);
                }}
              >
                Create bill
              </PaymentButton>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
  const desktopContent = (
    <Grid container>
      <Grid item xs={props.terminalBean.saleMode == "TOUCH_POS_TILE" ? 4 : 8}>
        <Grid container>
          {props.saleType === "SERVICE" && (
            <Grid item xs={12}>
              <ServiceDetailsPanel
                biRef={biRef}
                assigneeLabel={srAssigneeLabel}
                srNumber={srNumber}
                srAssignee={srAssignee}
                setSrAssignee={setSrAssignee}
                setSrNumber={setSrNumber}
                srAssigneeLabel={srAssigneeLabel}
                userOptions={userOptions}
                srEta={srEta}
                setSrEta={setSrEta}
                srStatus={srStatus}
                setSrStatus={setSrStatus}
                statusOptions={statusOptions}
              ></ServiceDetailsPanel>
            </Grid>
          )}
          <Grid item xs={12}>
            <SearchBar
              onAddProduct={onAddProduct}
              prompt={
                props.saleType == "SERVICE"
                  ? "Search for Service or Product"
                  : translate("Search or Scan the product")
              }
              isLookupEnabled={true}
              setShowProductLookup={setShowProductLookup}
              productCache={props.productCache}
              productCache2={props.productCache2}
              handleKeyPress={handleKeyPress}
              context={props.context}
            ></SearchBar>
          </Grid>
          <Grid item xs={12}>
            {saleListEngine == "ag-grid" &&
              props.context.appMode != "mobile" && (
                <TSaleListRo
                  biRef={biRef}
                  productCache={props.productCache}
                  productCache2={props.productCache2}
                  onAddProduct={onAddProduct}
                  saleData={saleData}
                  setSaleData={setSaleData}
                  rawData={rawSale}
                  onChangeValueEvent={onChangeValueEvent}
                  saleType={props.saleType}
                  context={props.context}
                  productType={
                    props.context.appType === "M_POS"
                      ? "P"
                      : props.context.appType === "R_POS"
                      ? "R"
                      : "I"
                  }
                ></TSaleListRo>
              )}

            <SaleList
              hideDisplay={
                props.context.appMode == "mobile" ||
                saleListEngine == "mui-datatable"
                  ? false
                  : true
              }
              data={saleData}
              rawData={rawSale}
              setRawSale={setRawSale}
              biRef={biRef}
              setSaleData={setSaleData}
              setAlert={props.setAlert}
              showMessage={props.showMessage}
              context={props.context}
              returnFlag={returnFlag}
              changeReturnFlag={setReturnFlag}
              colorPallet={colorPallet}
              mobile={false}
              saleSetting={saleSetting}
              // selectedSaleItemIndex={selectedSaleItemIndex}
              // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
              setValue={setValue}
              setCurrentScreen={setCurrentScreen}
              saleType={props.saleType}
              pricingBean={pricingBean}
              productBean={productBean}
              setProductBean={setProductBean}
              setPricingBean={setPricingBean}
              setServiceDataMode={setServiceDataMode}
              serviceDataMode={serviceDataMode}
              setCurrentRow={setCurrentRow}
              currentRow={currentRow}
              privileges={privileges}
              terminalBean={props.terminalBean}
              workflowStatus={workflowStatus}
              currentMenu={currentMenu}
              onChangeValueEvent={onChangeValueEvent}
              setProductKey={setProductKey}
            ></SaleList>
          </Grid>
          <Grid item xs={12}>
            <SaleSummary
              data={saleData}
              context={props.context}
              biRef={biRef}
              saleSetting={saleSetting}
              poleDisplayHandler={showOnPoleDisplay}
              saleType={props.saleType}
              terminalBean={props.terminalBean}
            ></SaleSummary>
          </Grid>
        </Grid>
      </Grid>
      {props.terminalBean.saleMode == "TOUCH_POS_TILE" && (
        <Grid xs={4}>
          <ProductTileView
            onAddProduct={onAddProduct}
            context={props.context}
          ></ProductTileView>
        </Grid>
      )}
      <Grid
        item
        xs={4}
        sx={{
          height:
            AgentUtils.getWindowDimensionsExAppBarsDualMode(
              props.context.appMode
            ).h - 350,
          paddingLeft: "10px",
        }}
      >
        <RightActionPanel
          biRef={biRef}
          context={props.context}
          resetSale={voidSaleWithAlert}
          returnFlag={returnFlag}
          saleSessionId={props.saleSessionId}
          terminalId={props.terminalId}
          changeReturnFlag={setReturnFlag}
          showPaymentWindow={showPaymentWindow}
          terminalBean={props.terminalBean}
          removeItem={removeItem}
          setAlert={props.setAlert}
          showMessage={props.showMessage}
          setShowHoldWindow={setShowHoldWindow}
          setShowUnHoldWindow={setShowUnHoldWindow}
          saleData={saleData}
          setShowCustomerLookupWindow={setShowCustomerLookupWindow}
          customerBean={customerBean}
          saleType={props.saleType}
          persistSale={persistSale}
          privileges={privileges}
          setPrivileges={setPrivileges}
          userName={currentUser}
          setCurrentUser={setCurrentUser}
          handleShowHistoryClick={handleShowHistoryClick}
          pdfViewer={props.pdfViewer}
          setAllowBarcodeScan={setAllowBarcodeScanFunc}
          saleSetting={saleSetting}
          reprint={reprint}
          openDrawer={openDrawer}
          holdSale={holdSale}
          setShowAuthScreen={setShowAuthScreen}
        ></RightActionPanel>
        <DigitPanel
          biRef={biRef}
          data={saleData}
          updateSaleData={updateSaleData}
          showMessage={props.showMessage}
          handleDigitPanelEvent={handleDigitPanelEvent}
          context={props.context}
          privileges={privileges}
          saleSetting={saleSetting}
        ></DigitPanel>
      </Grid>
    </Grid>
  );

  function handleDigitPanelEvent(type, value) {
    biRef.saleList.parentEvent(type, value);
  }
  function getHistoryTitle(type) {
    if (type === "R_SALE") return translate("Sale History");
    if (type === "SALE") return translate("Sale History");
    if (type === "SALE_RETURN") return translate("Return History");
    if (type === "SALE_ORDER")
      return translate(
        (props.context.storeAdmin.saleOrderName
          ? props.context.storeAdmin.saleOrderName
          : "Sale Order") + " History"
      );
    if (type === "SERVICE") return translate("Service History");
  }

  function getSaleTitle(type) {
    if (props.context.appType === "R_POS") {
      if (props.context.appMode === "mobile") {
        if (props.restaurantSaleType === "dineIn") return "Dine-in";
        if (props.restaurantSaleType === "takeAway") return "Takeaway";
      }
      return "eSale POS - Restaurant cloud";
    }
    if (type === "SALE") return translate("Sale");
    if (type === "SALE_RETURN") return translate("Sale Return");
    if (type === "SALE_ORDER")
      return translate(
        props.context.storeAdmin.saleOrderName
          ? props.context.storeAdmin.saleOrderName
          : "Sale Order"
      );
    if (type === "SERVICE") return translate("Service");
  }

  function getAlertTitle(type) {
    if (props.context.appType === "R_POS") {
      if (currentMenu === "dineIn") return "Dine-in";
      if (currentMenu === "takeAway") return "Takeaway";
      if (currentMenu === "delivery") return "Delivery";
    }
    return type;
  }

  function handleCustomerSelect(customerBean) {
    if (customerBean) {
      setCustomerBean(customerBean);
    }
  }

  function updateServiceDetails(payload, mode) {
    if (mode === "create") {
      let key = SaleUtils.deriveKey(
        saleData,
        productBean.id,
        pricingBean.unitType,
        returnFlag,
        "SERVICE" + (saleData.length + 1)
      );

      SaleUtils.addProductNew(
        rawSale,
        setRawSale,
        setSaleData,
        colorPallet,
        props.context,
        productBean,
        pricingBean,
        pricingBean.price,
        1,
        false,
        key,
        false,
        payload,
        setReturnFlag
      );
    }
    if (mode === "update") {
      let ix = SaleUtils.getCurrentRow(saleData);
      let dd = [...saleData];
      dd[ix][9].info.serviceMeta = payload;
      setSaleData(dd);

      let localRawSale = [...rawSale];
      localRawSale[
        SaleUtils.findRowSaleIndexByKey(localRawSale, dd[ix][9].info.key)
      ].serviceMeta = payload;
      setRawSale(localRawSale);
    }
    setServiceDataMode("update");
  }

  function clearServiceData() {
    setSrNumber("NEW");
    setSrStatus(SaleUtils.getOption(statusOptions, "OPEN"));
    setSrAssignee(null);
    setSrEta(null);
  }

  function closeLastSaleSummary() {
    setShowLastSaleSummary(false);
    setLastBill(null);
  }

  function handleKeyPress(event) {
    if (allowBarcodeScan) {
      if (
        event.key === "ArrowDown" ||
        event.key === "ArrowUp" ||
        event.key === "Delete"
      ) {
        if (biRef.saleList)
          biRef.saleList.parentEvent("onKeyPressed", event.key);
      } else if (event.key === "Backspace") {
        if (biRef.digitPanel)
          biRef.digitPanel.parentEvent("onKeyPressed", event.key);
      }
    }

    if (allowBarcodeScan) {
      if ("F1" == event.key) {
        event.preventDefault();
        if (privileges.return_buttun_allowed) {
          setReturnFlag(!returnFlag);
        }
      } else if ("F2" == event.key) {
        event.preventDefault();
        if (privileges.drawer_buttun_allowed) {
          openDrawer();
        }
      } else if ("F3" == event.key) {
        event.preventDefault();
        if (privileges.reprint_buttun_allowed) {
          reprint();
        }
      } else if ("F4" == event.key) {
        event.preventDefault();
        if (privileges.hold_buttun_allowed) {
          holdSale();
        }
      } else if ("F5" == event.key) {
        event.preventDefault();
        if (privileges.unhold_buttun_allowed) {
          setShowUnHoldWindow(true);
        }
      } else if ("F6" == event.key) {
        event.preventDefault();
        if (privileges.void_buttun_allowed) {
          voidSale();
        }
      } else if ("F7" == event.key) {
        event.preventDefault();
        if (privileges.History_buttun_allowed) {
          handleShowHistoryClick();
        }
      } else if ("F8" == event.key) {
        event.preventDefault();
        if (privileges.switch_button_allowed) {
          setShowAuthScreen(true);
        }
      } else if ("F9" == event.key) {
        event.preventDefault();
        if (privileges.remove_buttun_allowed) {
          removeItem();
        }
      } else if ("F10" == event.key) {
        event.preventDefault();
        if (privileges.customer_buttun_allowed) {
          setShowCustomerLookupWindow(true);
        }
      } else if ("F11" == event.key && props.saleType != "SERVICE") {
        event.preventDefault();
        showPaymentWindow(true);
      } else if ("F12" == event.key) {
        event.preventDefault();
      } else if (event.ctrlKey && ("P" == event.key || "p" == event.key)) {
        event.preventDefault();
        if (privileges.price_buttun_allowed) {
          handleDigitPanelEvent(
            "updatePrice",
            biRef.digitPanel.parentEvent("getDigits")
          );
          biRef.digitPanel.parentEvent("setDigits", "");
        }
      } else if (event.ctrlKey && ("Q" == event.key || "q" == event.key)) {
        event.preventDefault();
        if (privileges.qty_buttun_allowed) {
          handleDigitPanelEvent(
            "updateQty",
            biRef.digitPanel.parentEvent("getDigits")
          );
          biRef.digitPanel.parentEvent("setDigits", "");
        }
      } else if (event.ctrlKey && ("$" == event.key || "4" == event.key)) {
        event.preventDefault();
        if (privileges.disc_dollar_buttun_allowed) {
          handleDigitPanelEvent(
            "updateDiscountAmount",
            biRef.digitPanel.parentEvent("getDigits")
          );
          biRef.digitPanel.parentEvent("setDigits", "");
        }
      } else if (event.ctrlKey && ("%" == event.key || "5" == event.key)) {
        event.preventDefault();
        if (privileges.disc_percent_buttun_allowed) {
          handleDigitPanelEvent(
            "updateDiscountPer",
            biRef.digitPanel.parentEvent("getDigits")
          );
          biRef.digitPanel.parentEvent("setDigits", "");
        }
      }
    }
  }

  function openDrawer() {
    PrintUtils.openDrawer(props.terminalBean, props.setAlert, translate);
  }

  function reprint() {
    PrintUtils.rePrint(
      props.terminalBean,
      props.setAlert,
      translate,
      false,
      props.pdfViewer
    );
  }

  function holdSale() {
    if (saleData.length == 0) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Please add some items"),
      });
      return;
    }
    setShowHoldWindow(true);
  }

  function handlePyamentKeyEvent(event) {
    biRef.paymentWindow.parentEvent("onKeyPressed", event);
  }

  function onShiftClose() {
    if (
      Store.parseJwt(
        Store.get(
          props.context.appMode === "mobile"
            ? "m_refreshToken"
            : "w_refreshToken"
        )
      ).sub != currentUser
    ) {
      if (privileges.force_shift_close) {
        props.shiftClose("shift");
      } else {
        props.setAlert({
          show: true,
          title: translate("Alert!"),
          message: translate("You dont have permissions to close others Shift"),
        });
      }
    } else {
      props.shiftClose("shift");
    }
  }

  const tradingCOntent = (
    <Grid container>
      <Grid item xs={10}>
        <Grid container>
          <Grid item xs={12}>
            <SaleDetailsPanal
              biRef={biRef}
              setCustomerBean={setCustomerBean}
              customerBean={customerBean}
              tradingDate={tradingDate}
              setTradingDate={setTradingDate}
              setShowCustomerCrud={setShowCustomerCrud}
              // setShowCustomerLookupWindow={setShowCustomerLookupWindow}
            ></SaleDetailsPanal>
          </Grid>
          {props.saleType === "SERVICE" && (
            <Grid item xs={12}>
              <ServiceDetailsPanel
                biRef={biRef}
                assigneeLabel={srAssigneeLabel}
                srNumber={srNumber}
                srAssignee={srAssignee}
                setSrAssignee={setSrAssignee}
                setSrNumber={setSrNumber}
                srAssigneeLabel={srAssigneeLabel}
                userOptions={userOptions}
                srEta={srEta}
                setSrEta={setSrEta}
                srStatus={srStatus}
                setSrStatus={setSrStatus}
                statusOptions={statusOptions}
              ></ServiceDetailsPanel>
            </Grid>
          )}

          <Grid item xs={12}>
            <TSaleList
              biRef={biRef}
              productCache={props.productCache}
              productCache2={props.productCache2}
              onAddProduct={onAddProduct}
              saleData={saleData}
              rawData={rawSale}
              onChangeValueEvent={onChangeValueEvent}
              saleType={props.saleType}
              context={props.context}
              productType={
                props.context.appType === "M_POS"
                  ? "P"
                  : props.context.appType === "R_POS"
                  ? "R"
                  : "I"
              }
            ></TSaleList>
            <SaleList
              data={saleData}
              rawData={rawSale}
              setRawSale={setRawSale}
              biRef={biRef}
              setSaleData={setSaleData}
              setAlert={props.setAlert}
              showMessage={props.showMessage}
              context={props.context}
              returnFlag={returnFlag}
              changeReturnFlag={setReturnFlag}
              colorPallet={colorPallet}
              mobile={true}
              saleSetting={saleSetting}
              // selectedSaleItemIndex={selectedSaleItemIndex}
              // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
              setValue={setValue}
              setCurrentScreen={setCurrentScreen}
              saleType={props.saleType}
              pricingBean={pricingBean}
              productBean={productBean}
              setProductBean={setProductBean}
              setPricingBean={setPricingBean}
              setServiceDataMode={setServiceDataMode}
              serviceDataMode={serviceDataMode}
              setCurrentRow={setCurrentRow}
              currentRow={currentRow}
              privileges={privileges}
              terminalBean={props.terminalBean}
              workflowStatus={workflowStatus}
              currentMenu={currentMenu}
              onChangeValueEvent={onChangeValueEvent}
              setProductKey={setProductKey}
            ></SaleList>
          </Grid>
          <Grid item xs={12}>
            <SaleSummary
              data={saleData}
              context={props.context}
              biRef={biRef}
              saleSetting={saleSetting}
              poleDisplayHandler={showOnPoleDisplay}
              saleType={props.saleType}
              terminalBean={props.terminalBean}
            ></SaleSummary>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs={2}>
        <TradingActionPanel
          biRef={biRef}
          context={props.context}
          resetSale={voidSale}
          returnFlag={returnFlag}
          saleSessionId={props.saleSessionId}
          terminalId={props.terminalId}
          changeReturnFlag={setReturnFlag}
          showPaymentWindow={showPaymentWindow}
          terminalBean={props.terminalBean}
          removeItemAgGrid={removeItemAgGrid}
          setAlert={props.setAlert}
          showMessage={props.showMessage}
          setShowHoldWindow={setShowHoldWindow}
          setShowUnHoldWindow={setShowUnHoldWindow}
          saleData={saleData}
          setShowCustomerLookupWindow={setShowCustomerLookupWindow}
          customerBean={customerBean}
          saleType={props.saleType}
          persistSale={persistSale}
          privileges={privileges}
          setPrivileges={setPrivileges}
          userName={currentUser}
          setCurrentUser={setCurrentUser}
          handleShowHistoryClick={handleShowHistoryClick}
          pdfViewer={props.pdfViewer}
          setCurrentScreen={setCurrentScreen}
          paymentMode={paymentMode}
          setPaymentMode={setPaymentMode}
          salesMans={salesMans}
          salesManInfo={salesManInfo}
          setSalesManInfo={setSalesManInfo}
          value={value}
          setValue={setValue}
          setShowValueCapture={setShowValueCapture}
          getAgGridCurrentRow={getAgGridCurrentRow}
          setTradingScreenPaymentModeSelect={setTradingScreenPaymentModeSelect}
          tradingScreenPaymentModeSelect={tradingScreenPaymentModeSelect}
        ></TradingActionPanel>
      </Grid>
    </Grid>
  );

  const rpos_desktop_content = (
    <div>
      <Grid container style={{ fontSize: "0.9rem" }}>
        <Grid xs={5}>
          <Grid container>
            {storeAdminSetting && storeAdminSetting.rTakeAway && (
              <Grid xs={12 / rMenuCount}>
                <MenuButton
                  style={{
                    color: theme.palette.getContrastText(blue[500]),
                    backgroundColor:
                      currentMenu === "takeAway" ? orange[700] : grey[700],
                  }}
                  onClick={() => {
                    if (currentMenu === "takeAway") {
                      voidSale();
                    } else {
                      setCurrentMenu("takeAway");
                    }
                  }}
                >
                  Take Away
                </MenuButton>
              </Grid>
            )}
            {storeAdminSetting && storeAdminSetting.rDineIn && (
              <Grid xs={12 / rMenuCount} sx={{ pl: "4px" }}>
                <MenuButton
                  style={{
                    color: theme.palette.getContrastText(blue[700]),
                    backgroundColor:
                      currentMenu === "dineIn" ? orange[700] : grey[700],
                  }}
                  onClick={() => {
                    if (currentMenu === "dineIn") {
                      voidSale();
                      setTableSelectionEventSource("dineIn");
                      setShowTableSelector(true);
                    } else {
                      setCurrentMenu("dineIn");
                    }
                  }}
                >
                  Dine - in
                </MenuButton>
              </Grid>
            )}

            {storeAdminSetting && storeAdminSetting.rDelivery && (
              <Grid xs={12 / rMenuCount} sx={{ pl: "4px" }}>
                <MenuButton
                  onClick={() => {
                    if (currentMenu === "delivery") {
                      voidSale();
                    } else {
                      setCurrentMenu("delivery");
                    }
                  }}
                  style={{
                    color: theme.palette.getContrastText(blue[700]),
                    backgroundColor:
                      currentMenu === "delivery" ? orange[700] : grey[700],
                  }}
                >
                  Delivery
                </MenuButton>
              </Grid>
            )}
            {/*storeAdminSetting && storeAdminSetting.rOnline && (
              <Grid xs={12 / rMenuCount}>
                <MenuButton
                  style={{
                    color: theme.palette.getContrastText(blue[500]),
                    backgroundColor:
                      currentMenu === "online" ? orange[700] : grey[700],
                  }}
                  onClick={() => {
                    setCurrentMenu("online");
                  }}
                >
                  Online
                </MenuButton>
              </Grid>
                )*/}

            <Grid item xs={3}>
              <Grid container>
                <Grid xs={12}>
                  <Typography>Queue</Typography>
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      height: AgentUtils.getWindowDimensionsExAppBars().h - 10,
                      overflow: "auto",
                      display: "block",
                      background: "#eee",
                      width: "100%",
                    }}
                  >
                    <Grid container>
                      {currentQueue.map((item, index) => (
                        <Grid item xs={12} sx={{ paddingTop: "2px" }}>
                          <QueueButton
                            style={{
                              padding: "2px",
                              color:
                                selectedQueue.id === item.id
                                  ? theme.palette.getContrastText(orange[900])
                                  : theme.palette.getContrastText(grey[600]),
                              backgroundColor:
                                selectedQueue.id === item.id
                                  ? orange[700]
                                  : grey[600],
                              height:
                                currentMenu === "dineIn" ? "40px" : "35px",
                            }}
                            onClick={() => {
                              setSelectedQueue(item);
                              openRestaurantOrder(item.id);
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                              }}
                            >
                              <Grid container>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{
                                    paddingTop: "5px",
                                    paddingLeft: "2px",
                                  }}
                                >
                                  {item.workflowStatus === "IN PROGRESS" && (
                                    <DoneIcon
                                      sx={{ fontSize: "medium" }}
                                    ></DoneIcon>
                                  )}
                                  {(item.workflowStatus === "PREPARED" ||
                                    item.workflowStatus === "BILL CREATED") && (
                                    <DoneAllIcon
                                      sx={{ fontSize: "medium" }}
                                    ></DoneAllIcon>
                                  )}
                                  {item.workflowStatus === "ON THE WAY" && (
                                    <DeliveryDiningTwoToneIcon
                                      sx={{ fontSize: "medium" }}
                                    ></DeliveryDiningTwoToneIcon>
                                  )}{" "}
                                  {item.workflowStatus === "DELIVERED" && (
                                    <CheckCircleTwoToneIcon
                                      sx={{
                                        fontSize: "medium",
                                      }}
                                    ></CheckCircleTwoToneIcon>
                                  )}
                                </Grid>
                                <Grid item xs={5}>
                                  <Typography
                                    variant="subtitle1"
                                    component="div"
                                    sx={{
                                      fontSize: "18",
                                      paddingBottom: "0px",
                                    }}
                                  >
                                    {item.token}
                                  </Typography>
                                </Grid>

                                <Grid item xs={5} style={{ paddingTop: "5px" }}>
                                  {item.strElapsed}
                                </Grid>

                                {currentMenu === "dineIn" && (
                                  <Grid
                                    item
                                    xs={12}
                                    style={{
                                      paddingLeft: "2px",
                                    }}
                                  >
                                    <Grid container>
                                      {item.tables &&
                                        item.tables.map((table, index) => (
                                          <Grid
                                            item
                                            xs={12 / item.tables.length}
                                          >
                                            {table.tableName}
                                          </Grid>
                                        ))}
                                    </Grid>
                                  </Grid>
                                )}
                              </Grid>
                            </div>
                          </QueueButton>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={9} sx={{ backgroundColor: "lightgray" }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sx={{
                    height:
                      currentMenu == "delivery"
                        ? workflowStatus == "NEW"
                          ? "160px"
                          : "220px"
                        : workflowStatus == "NEW"
                        ? currentMenu == "dineIn"
                          ? "120px"
                          : "100px"
                        : currentMenu == "dineIn"
                        ? "180px"
                        : "160px",
                    margin: "5px",
                  }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sx={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      <ActionButton
                        sx={{
                          backgroundColor: blue[700],
                          "&:hover": {
                            backgroundColor: blue[700],
                          },
                          color: "white",
                          height: "30px",
                        }}
                        onClick={() => {
                          setShowCustomerLookupWindow(true);
                        }}
                      >
                        {"Customer" +
                          (customerBean ? "(" + customerBean.name + ")" : "")}
                      </ActionButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        height: currentMenu == "delivery" ? "120px" : "50px",
                      }}
                    >
                      <table width={"100%"}>
                        <tbody>
                          <tr>
                            <td style={{ width: "120px" }}>Token</td>{" "}
                            <td>{selectedQueue ? selectedQueue.token : ""}</td>
                            <td>Status</td> <td>{workflowStatus}</td>
                          </tr>
                          <tr>
                            <td>Contact</td>{" "}
                            <td colspan={3}>
                              {customerBean ? customerBean.mobile : ""}
                            </td>
                          </tr>
                          {currentMenu === "delivery" && (
                            <tr>
                              <td>Address</td>{" "}
                              <td colspan={3}>
                                {customerBean ? customerBean.address1 : ""}
                              </td>
                            </tr>
                          )}
                          {currentMenu === "delivery" && (
                            <tr>
                              <td>
                                <ActionButton
                                  sx={{
                                    backgroundColor: blue[700],
                                    "&:hover": {
                                      backgroundColor: blue[700],
                                    },
                                    color: "white",
                                    width: "100px",
                                  }}
                                  onClick={() => {
                                    seltShowDeliveryPersonLookup(true);
                                  }}
                                >
                                  Sales Man
                                </ActionButton>
                              </td>
                              <td colspan={3}>
                                {salesManInfo ? salesManInfo.name : "Jose"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </Grid>

                    {currentMenu === "dineIn" && (
                      <Grid item xs={12} sx={{ marginTop: "5px" }}>
                        <Grid container>
                          <Grid item xs={2} sx={{ paddingLeft: "10px" }}>
                            <IconButton
                              color="primary"
                              aria-label="add to shopping cart"
                              style={{ padding: "0px" }}
                              onClick={() => {
                                setTableSelectionEventSource("table_button");
                                setShowTableSelector(true);
                              }}
                            >
                              <TableRestaurantIcon />
                            </IconButton>
                          </Grid>
                          {tableInfo &&
                            tableInfo.map((table, index) => (
                              <Grid item xs={2} style={{ padding: "2px" }}>
                                <div
                                  style={{
                                    backgroundColor: "#feff9c",
                                    textAlign: "center",
                                  }}
                                >
                                  {table.tableName}
                                </div>
                              </Grid>
                            ))}
                        </Grid>
                      </Grid>
                    )}
                    {workflowStatus != "NEW" && (
                      <Grid item xs={12} sx={{ marginTop: "5px" }}>
                        Work Flow
                      </Grid>
                    )}
                    {workflowStatus != "NEW" && (
                      <Grid item xs={4} sx={{ paddingLeft: "5px" }}>
                        <ActionButton
                          sx={{
                            backgroundColor: red[700],
                            "&:hover": {
                              backgroundColor: red[700],
                            },
                            fontSize: "0.70rem",
                            color: "white",
                          }}
                          onClick={() => {
                            updateSaleStatus(uuid, "CANCELLED");
                          }}
                        >
                          Cancel
                        </ActionButton>
                      </Grid>
                    )}
                    {workflowStatus == "CREATED" && (
                      <Grid item xs={4} sx={{ paddingLeft: "5px" }}>
                        <ActionButton
                          sx={{
                            backgroundColor: blue[700],
                            "&:hover": {
                              backgroundColor: blue[700],
                            },
                            fontSize: "0.70rem",
                            color: "white",
                          }}
                          onClick={() => {
                            updateSaleStatus(uuid, "IN PROGRESS");
                          }}
                        >
                          In Progress
                        </ActionButton>
                      </Grid>
                    )}
                    {workflowStatus == "IN PROGRESS" && (
                      <Grid item xs={4} sx={{ paddingLeft: "5px" }}>
                        <ActionButton
                          sx={{
                            backgroundColor: blue[700],
                            "&:hover": {
                              backgroundColor: blue[700],
                            },
                            fontSize: "0.70rem",
                            color: "white",
                          }}
                          onClick={() => {
                            updateSaleStatus(uuid, "PREPARED");
                          }}
                        >
                          Prepared
                        </ActionButton>
                      </Grid>
                    )}
                    {currentMenu === "delivery" &&
                      workflowStatus == "BILL CREATED" && (
                        <Grid item xs={6} sx={{ paddingLeft: "5px" }}>
                          <ActionButton
                            sx={{
                              backgroundColor: blue[700],
                              "&:hover": {
                                backgroundColor: blue[700],
                              },
                              fontSize: "0.70rem",
                              color: "white",
                            }}
                            onClick={() => {
                              updateSaleStatus(uuid, "ON THE WAY");
                            }}
                          >
                            Out For Delivery
                          </ActionButton>
                        </Grid>
                      )}
                    {currentMenu === "delivery" &&
                      workflowStatus == "ON THE WAY" && (
                        <Grid item xs={6} sx={{ paddingLeft: "5px" }}>
                          <ActionButton
                            sx={{
                              backgroundColor: blue[700],
                              "&:hover": {
                                backgroundColor: blue[700],
                              },
                              fontSize: "0.70rem",
                              color: "white",
                            }}
                            onClick={() => {
                              updateSaleStatus(uuid, "DELIVERED");
                            }}
                          >
                            Delivered
                          </ActionButton>
                        </Grid>
                      )}
                    {/*workflowStatus != "NEW" && (
                      <Grid item xs={4} sx={{ paddingLeft: "5px" }}>
                        <ActionButton
                          sx={{
                            backgroundColor: green[700],
                            "&:hover": {
                              backgroundColor: green[700],
                            },
                            fontSize: "0.70rem",
                            color: "white",
                          }}
                          onClick={() => {
                            showPaymentWindow("IN PROGRESS");
                          }}
                        >
                          Settle
                        </ActionButton>
                      </Grid>
                        )*/}
                  </Grid>
                </Grid>
                <Grid xs={12} sx={{ paddingLeft: "4px" }}>
                  <SearchBar
                    onAddProduct={onAddProduct}
                    isLookupEnabled={true}
                    prompt={"Search for Item"}
                    setShowProductLookup={setShowProductLookup}
                    productCache={props.productCache}
                    productCache2={props.productCache2}
                    handleKeyPress={handleKeyPress}
                    context={props.context}
                  ></SearchBar>
                </Grid>
                <Grid item xs={12} sx={{ padding: "4px" }}>
                  <SaleList
                    data={saleData}
                    rawData={rawSale}
                    setRawSale={setRawSale}
                    biRef={biRef}
                    setSaleData={setSaleData}
                    setAlert={props.setAlert}
                    showMessage={props.showMessage}
                    context={props.context}
                    returnFlag={returnFlag}
                    changeReturnFlag={setReturnFlag}
                    colorPallet={colorPallet}
                    mobile={true}
                    saleSetting={saleSetting}
                    // selectedSaleItemIndex={selectedSaleItemIndex}
                    // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
                    setValue={setValue}
                    setCurrentScreen={setCurrentScreen}
                    saleType={props.saleType}
                    pricingBean={pricingBean}
                    productBean={productBean}
                    setProductBean={setProductBean}
                    setPricingBean={setPricingBean}
                    setServiceDataMode={""}
                    serviceDataMode={null}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    privileges={privileges}
                    terminalBean={props.terminalBean}
                    currentMenu={currentMenu}
                    workflowStatus={workflowStatus}
                    onChangeValueEvent={onChangeValueEvent}
                    setProductKey={setProductKey}
                  ></SaleList>
                </Grid>
                <Grid item xs={12} sx={{ padding: "4px" }}>
                  <SaleSummary
                    data={saleData}
                    context={props.context}
                    biRef={biRef}
                    mobile={true}
                    saleSetting={saleSetting}
                    saleType={props.saleType}
                    terminalBean={props.terminalBean}
                  ></SaleSummary>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={7}>
          <Grid container>
            <Grid item xs={12}>
              <ProductTileView
                onAddProduct={onAddProduct}
                context={props.context}
              ></ProductTileView>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  <DigitPanel
                    biRef={biRef}
                    data={saleData}
                    updateSaleData={updateSaleData}
                    showMessage={props.showMessage}
                    handleDigitPanelEvent={handleDigitPanelEvent}
                    context={props.context}
                    privileges={privileges}
                    saleSetting={saleSetting}
                  ></DigitPanel>
                </Grid>
                <Grid item xs={6}>
                  <RestaurantActionPanel
                    biRef={biRef}
                    context={props.context}
                    resetSale={voidSale}
                    returnFlag={returnFlag}
                    saleSessionId={props.saleSessionId}
                    terminalId={props.terminalId}
                    changeReturnFlag={setReturnFlag}
                    showPaymentWindow={showPaymentWindow}
                    terminalBean={props.terminalBean}
                    removeItem={removeItem}
                    setAlert={props.setAlert}
                    showMessage={props.showMessage}
                    setShowHoldWindow={setShowHoldWindow}
                    setShowUnHoldWindow={setShowUnHoldWindow}
                    saleData={saleData}
                    setShowCustomerLookupWindow={setShowCustomerLookupWindow}
                    customerBean={customerBean}
                    saleType={props.saleType}
                    persistSale={persistSale}
                    privileges={privileges}
                    setPrivileges={setPrivileges}
                    userName={currentUser}
                    setCurrentUser={setCurrentUser}
                    handleShowHistoryClick={handleShowHistoryClick}
                    pdfViewer={props.pdfViewer}
                    workflowStatus={workflowStatus}
                    parentSaleBean={parentSaleBean}
                    updateSaleStatus={updateSaleStatus}
                    setCurrentScreen={setCurrentScreen}
                    setValue={setValue}
                    currentMenu={currentMenu}
                    createBill={createBill}
                    enableKot={enableKot}
                    setEnableKot={setEnableKot}
                  ></RestaurantActionPanel>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  function getSaleContent() {
    if (props.context.appType === "R_POS") {
      if (props.context.appMode === "mobile") {
        return r_pos_mobile_content;
      } else {
        return rpos_desktop_content;
      }
    }
    if (props.terminalBean.saleMode == "KEYBOARD_TRADING") {
      return tradingCOntent;
    }

    return props.context.appMode === "desktop-pos"
      ? desktopContent
      : mobileContent;
  }

  const divRef = useRef();

  return (
    <div ref={divRef}>
      {currentScreen === "sale" && (
        <BarcodeReader
          onError={rejectdBarcode}
          onScan={onBarcodeScanned}
          avgTimeByChar={
            props.context.storeAdmin.barcodeScanAvgTimeByChar
              ? props.context.storeAdmin.barcodeScanAvgTimeByChar
              : 30
          }
        />
      )}
      {cacheLoaded && currentScreen === "sale" && (
        <ThemeProvider theme={theme}>
          <MScreen
            onKeyDown={handleKeyPress}
            title={
              getSaleTitle(props.saleType) +
              (parentSaleBean
                ? " [" +
                  (props.context.appType === "R_POS"
                    ? parentSaleBean.token
                    : parentSaleBean.invoiceNo) +
                  "]"
                : "")
            }
            isMoreMenuEnabled={true}
            onRedirectToBack={() => {
              showOnPoleDisplay(null, null);

              if (
                props.context.appMode == "mobile" &&
                props.context.appType === "R_POS"
              ) {
                setCurrentScreen("dineIn_home");
              } else props.setCurrentPage("home");
            }}
            onRedirectToHome={() => props.setCurrentPage("home")}
            content={getSaleContent()}
            dialogeSideMenuOptions={getSideMenu()}
            onLogOut={props.onLogOut}
            context={props.context}
            enableSwitchUser={false}
            enableClock={true}
            clockPrefix={clockPrefix}
            setPrivileges={setPrivileges}
            userName={currentUser}
            setCurrentUser={setCurrentUser}
            onShiftClose={onShiftClose}
          ></MScreen>
        </ThemeProvider>
      )}
      {cacheLoaded && currentScreen === "dineIn_home" && (
        <ThemeProvider theme={theme}>
          <MScreen
            onKeyDown={handleKeyPress}
            title={
              getSaleTitle(props.saleType) +
              (parentSaleBean
                ? " [" +
                  (props.context.appType === "R_POS"
                    ? parentSaleBean.token
                    : parentSaleBean.invoiceNo) +
                  "]"
                : "")
            }
            isMoreMenuEnabled={true}
            onRedirectToBack={() => {
              showOnPoleDisplay(null, null);
              props.setCurrentPage("home");
            }}
            onRedirectToHome={() => props.setCurrentPage("home")}
            content={
              <RestaurantHome
                context={props.context}
                currentQueue={currentQueue}
                openRestaurantOrder={openRestaurantOrder}
                setCurrentScreen={setCurrentScreen}
                voidSale={voidSale}
                restaurantSaleType={props.restaurantSaleType}
              />
            }
            dialogeSideMenuOptions={getSideMenu()}
            onLogOut={props.onLogOut}
            context={props.context}
            enableSwitchUser={false}
            enableClock={true}
            clockPrefix={clockPrefix}
            setPrivileges={setPrivileges}
            userName={currentUser}
            setCurrentUser={setCurrentUser}
            onShiftClose={onShiftClose}
          ></MScreen>
        </ThemeProvider>
      )}
      {(currentScreen === "payment" || showPaymentScreen) && (
        <ThemeProvider theme={theme}>
          <MScreen
            onKeyDown={handlePyamentKeyEvent}
            title={"Payment"}
            isMoreMenuEnabled={false}
            onRedirectToBack={() => {
              if (props.context.appMode === "mobile") {
                isCustomFieldRequired
                  ? setCurrentScreen("custom_fields")
                  : setCurrentScreen("sale");
              }
              if (props.context.appMode === "desktop-pos") {
                setShowPaymentScreen(false);
              }
            }}
            onRedirectToHome={() => props.setCurrentPage("home")}
            onLogOut={props.onLogOut}
            dialogMode={true}
            position={
              props.context.appMode === "desktop-pos" ? "static" : "fixed"
            }
            context={props.context}
            content={
              <MPaymentWindow
                biRef={biRef}
                setCurrentScreen={setCurrentScreen}
                saleData={saleData}
                context={props.context}
                customerBean={customerBean}
                onSave={props.context.appType === "R_POS" ? onRPOSSave : onSave}
                setAlert={props.setAlert}
                isCustomFieldRequired={isCustomFieldRequired}
                setIsCustomFieldRequired={setIsCustomFieldRequired}
                customFields={customFields}
                setCustomFields={setCustomFields}
                saleSetting={saleSetting}
                saleType={props.saleType === "R_SALE" ? "SALE" : props.saleType} //Little Hack :)
                setSaleData={setSaleData}
                setRawSale={setRawSale}
                setCustomerBean={setCustomerBean}
                resetCustomFields={resetCustomFields}
                parentSaleBean={parentSaleBean}
                onLogOut={props.onLogOut}
                payCodeConfigs={payCodeConfigs}
                terminalBean={props.terminalBean}
                privileges={privileges}
                poleDisplayHandler={showOnPoleDisplay}
              ></MPaymentWindow>
            }
          ></MScreen>
        </ThemeProvider>
      )}
      {currentScreen === "saleHistory" && (
        <MList
          title={getHistoryTitle(props.saleType)}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          onLogOut={props.onLogOut}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={props.saleType}
              eventSource={"SALE_HISTORY"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              onLogOut={props.onLogOut}
              saleSession={props.saleSession}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              handleSelectSale={handleSelectSale}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "saleHistory1" && (
        <MList
          title={getHistoryTitle("SALE")}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          onLogOut={props.onLogOut}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={"SALE"}
              eventSource={"SALE_HISTORY"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              onLogOut={props.onLogOut}
              saleSession={props.saleSession}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              handleSelectSale={handleSelectSale}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "productLookup" && (
        <MList
          title={"Prouduct Lookup"}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <ProductList
              readOnly={true}
              showMessage={props.showMessage}
              setAlert={props.setAlert}
              setProgressMessage={props.setProgressMessage}
              context={props.context}
              productType={
                props.context.appType === "M_POS"
                  ? "P"
                  : props.context.appType === "R_POS"
                  ? "R"
                  : "I"
              }
              unitTypeOptions={unitTypeOptions}
              productInfoFields={productInfoFields}
              from={from}
            ></ProductList>
          }
        ></MList>
      )}
      {currentScreen === "saleReturnHistory" && (
        <MList
          title={getHistoryTitle(props.saleType)}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={props.saleType}
              eventSource={"SALE_RETURN_HISTORY"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              onLogOut={props.onLogOut}
              saleSession={props.saleSession}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "saleOrderHistory" && (
        <MList
          title={getHistoryTitle(props.saleType)}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={props.saleType}
              eventSource={"SALE_ORDER_HISTORY"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              onLogOut={props.onLogOut}
              saleSession={props.saleSession}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "saleHistoryInReturn" && (
        <MList
          title={translate("Sale History")}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={"SALE"}
              eventSource={"SALE_IN_RETURN"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              saleSession={props.saleSession}
              handleSelectSale={handleSelectSale}
              onLogOut={props.onLogOut}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "saleOrderInSale" && (
        <MList
          title={translate(
            (props.context.storeAdmin.saleOrderName
              ? props.context.storeAdmin.saleOrderName
              : "Sale Order") + " History"
          )}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          onLogOut={props.onLogOut}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={"SALE_ORDER"}
              eventSource={"SALE_ORDER_IN_SALE"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              saleSession={props.saleSession}
              handleSelectSale={handleSelectSale}
              createInvoiceFromSaleOrder={createInvoiceFromSaleOrder}
              onLogOut={props.onLogOut}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "serviceInSale" && (
        <MList
          title={translate("Service History")}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          onLogOut={props.onLogOut}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={"SERVICE"}
              eventSource={"SERVICE_IN_SALE"}
              showMessage={props.showMessage}
              context={props.context}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              saleSession={props.saleSession}
              setAlert={props.setAlert}
              handleSelectSale={handleSelectService}
              createInvoiceFromService={createInvoiceFromService}
              onLogOut={props.onLogOut}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "value_capture_note" && (
        <MValueCapture
          value={value}
          setValue={setValue}
          textLabel={translate("Note")}
          onBack={(value) => {
            setCurrentScreen("sale");
          }}
          setCurrentScreen={setCurrentScreen}
          mode="value_capture_note"
          onOkay={onNoteAdded}
          onLogOut={props.onLogOut}
          context={props.context}
          setShowValueCapture={setShowValueCapture}
        ></MValueCapture>
      )}
      {showValueCapture && (
        <MValueCapture
          value={value}
          setValue={setValue}
          textLabel={translate("Note")}
          onBack={(value) => {
            setCurrentScreen("sale");
          }}
          setCurrentScreen={setCurrentScreen}
          mode="value_capture_note"
          onOkay={onNoteAddedAgGrid}
          onLogOut={props.onLogOut}
          context={props.context}
          setShowValueCapture={setShowValueCapture}
        ></MValueCapture>
      )}
      {currentScreen === "value_capture_qty" && (
        <MValueCapture
          value={value}
          productKey={productKey}
          setValue={setValue}
          textLabel={translate("Quantity")}
          onBack={(value) => {
            setCurrentScreen("sale");
          }}
          type={"number"}
          onOkay={(value) => {
            onChangeValueEvent(value, "updateQty");
          }}
          onLogOut={props.onLogOut}
        ></MValueCapture>
      )}{" "}
      {currentScreen === "value_capture_price" && (
        <MValueCapture
          value={value}
          setValue={setValue}
          textLabel={translate("Change Price")}
          onBack={(value) => {
            setCurrentScreen("sale");
          }}
          type={"number"}
          onOkay={(value) => {
            onChangeValueEvent(value, "updatePrice");
          }}
          onLogOut={props.onLogOut}
        ></MValueCapture>
      )}
      {currentScreen === "value_capture_disc" && (
        <MValueCapture
          value={value}
          setValue={setValue}
          textLabel={translate("Discount Amount")}
          onBack={(value) => {
            setCurrentScreen("sale");
          }}
          type={"number"}
          onOkay={(value) => {
            onChangeValueEvent(value, "updateDiscountAmount");
          }}
          onLogOut={props.onLogOut}
        ></MValueCapture>
      )}
      {currentScreen === "open_qty_price" && (
        <MOpenQtyPrice
          productKey={productKey}
          productBean={productBean}
          pricingBean={pricingBean}
          setCurrentScreen={setCurrentScreen}
          context={props.context}
          onChangeQtyAndPrice={onChangeQtyAndPrice}
          onChangePrice={onChangePrice}
          onLogOut={props.onLogOut}
        ></MOpenQtyPrice>
      )}
      {currentScreen === "custom_fields" && (
        <MCustomFields
          setCurrentScreen={setCurrentScreen}
          context={props.context}
          customFields={customFields}
          setCustomFields={setCustomFields}
          onLogOut={props.onLogOut}
        ></MCustomFields>
      )}
      {currentScreen === "customer_search" && (
        <MCustomerSearch
          onCustomerSelect={handleCustomerSelect}
          setCurrentScreen={setCurrentScreen}
        ></MCustomerSearch>
      )}
      {currentScreen === "service_details" && (
        <MServiceDetails
          productBean={productBean}
          pricingBean={pricingBean}
          setCurrentScreen={setCurrentScreen}
          context={props.context}
          onLogOut={props.onLogOut}
          setServiceDataMode={setServiceDataMode}
          serviceDataMode={serviceDataMode}
          updateServiceDetails={updateServiceDetails}
          currentRow={currentRow}
        ></MServiceDetails>
      )}
      {currentScreen === "edit_service_summary" && (
        <MEditService
          setCurrentScreen={setCurrentScreen}
          context={props.context}
          onLogOut={props.onLogOut}
          srNumber={srNumber}
          srAssignee={srAssignee}
          setSrAssignee={setSrAssignee}
          setSrNumber={setSrNumber}
          srAssigneeLabel={srAssigneeLabel}
          userOptions={userOptions}
          srEta={srEta}
          setSrEta={setSrEta}
          srStatus={srStatus}
          setSrStatus={setSrStatus}
          statusOptions={statusOptions}
        ></MEditService>
      )}
      {currentScreen === "serviceHistory" && (
        <MList
          title={getHistoryTitle(props.saleType)}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <MSaleHistory
              saleType={props.saleType}
              eventSource={"SERIVCE_HISTORY"}
              showMessage={props.showMessage}
              context={props.context}
              saleSession={props.saleSession}
              showProgress={props.showProgress}
              hideProgress={props.hideProgress}
              terminalBean={props.terminalBean}
              setAlert={props.setAlert}
              onLogOut={props.onLogOut}
              handleSelectService={handleSelectService}
              userOptions={userOptions}
              statusOptions={statusOptions}
              srAssigneeLabel={srAssigneeLabel}
              terminalOptions={terminalOptions}
              pdfViewer={props.pdfViewer}
              storeAdminSetting={storeAdminSetting}
              paymentSettings={paymentSettings}
            ></MSaleHistory>
          }
        ></MList>
      )}
      {currentScreen === "dineIn_item_select" && (
        <MList
          title={"Items"}
          isMoreMenuEnabled={false}
          onRedirectToHome={() => props.setCurrentPage("home")}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          content={
            <div>
              <ProductTileView
                onAddProduct={onAddProduct}
                context={props.context}
                setCurrentScreen={setCurrentScreen}
              ></ProductTileView>
              <SaleList
                data={saleData}
                rawData={rawSale}
                setRawSale={setRawSale}
                biRef={biRef}
                setSaleData={setSaleData}
                setAlert={props.setAlert}
                showMessage={props.showMessage}
                context={props.context}
                returnFlag={returnFlag}
                changeReturnFlag={setReturnFlag}
                colorPallet={colorPallet}
                mobile={true}
                saleSetting={saleSetting}
                // selectedSaleItemIndex={selectedSaleItemIndex}
                // setSelectedSaleItemIndex={setSelectedSaleItemIndex}
                setValue={setValue}
                setCurrentScreen={setCurrentScreen}
                saleType={props.saleType}
                pricingBean={pricingBean}
                productBean={productBean}
                setProductBean={setProductBean}
                setPricingBean={setPricingBean}
                setServiceDataMode={setServiceDataMode}
                serviceDataMode={serviceDataMode}
                setCurrentRow={setCurrentRow}
                currentRow={currentRow}
                privileges={privileges}
                terminalBean={props.terminalBean}
                workflowStatus={workflowStatus}
                hideDisplay={true}
                onChangeValueEvent={onChangeValueEvent}
                setProductKey={setProductKey}
              ></SaleList>
            </div>
          }
        ></MList>
      )}
      {currentScreen === "dineIn_table_select" && (
        <TableSelector
          title={"Tables"}
          isMoreMenuEnabled={false}
          onRedirectToBack={() => setCurrentScreen("sale")}
          dialogMode={true}
          position={
            props.context.appMode === "desktop-pos" ? "static" : "fixed"
          }
          maxWidth={"xl"}
          rightAction={translate("OK")}
          enbaleRightAction={true}
          setTableInfo={setTableInfo}
          setCurrentPage={props.setCurrentPage}
          setCurrentScreen={setCurrentScreen}
          context={props.context}
        ></TableSelector>
      )}
      <SaleDao
        createPayload={createPayload}
        customerBean={customerBean}
        setCurrentScreen={setCurrentScreen}
        setSaleData={setSaleData}
        setRawSale={setRawSale}
        setCustomerBean={setCustomerBean}
        resetCustomFields={resetCustomFields}
        biRef={biRef}
        context={props.context}
        showMessage={props.showMessage}
        saleType={props.saleType}
        paymentEvent={paymentEvent}
        setParentSaleBean={setParentSaleBean}
        terminalBean={props.terminalBean}
        setAlert={props.setAlert}
        onLogOut={props.onLogOut}
        setUuid={setUuid}
        uuid={uuid}
        setInvoiceNumber={setInvoiceNumber}
        clearServiceData={clearServiceData}
        setParentType={setParentType}
        holdMode={false}
        setHoldNote={setHoldNote}
        setCustomerBeanForHold={setCustomerBeanForHold}
        setLastBill={setLastBill}
        setShowLastSaleSummary={setShowLastSaleSummary}
        setShowPaymentScreen={setShowPaymentScreen}
        setPrivileges={setPrivileges}
        setCurrentUser={setCurrentUser}
        pdfViewer={props.pdfViewer}
        currentMenu={currentMenu}
        currentQueue={currentQueue}
        refreshQueue={refreshQueue}
        setSelectedQueue={setSelectedQueue}
        setworkflowStatus={setworkflowStatus}
        setTableInfo={setTableInfo}
        setSalesManInfo={setSalesManInfo}
        setTradingDate={setTradingDate}
        nextInvoiceNo={nextInvoiceNo}
        setNextInvoiceNo={setNextInvoiceNo}
        editMode={editMode}
        setEditMode={setEditMode}
        setTradingScreenPaymentModeSelect={setTradingScreenPaymentModeSelect}
      ></SaleDao>
      {/*For R_POS settlement*/}
      <SaleDao
        createPayload={createPayload}
        customerBean={customerBean}
        setCurrentScreen={setCurrentScreen}
        setSaleData={setSaleData}
        setRawSale={setRawSale}
        setCustomerBean={setCustomerBean}
        resetCustomFields={resetCustomFields}
        biRef={biRef3}
        context={props.context}
        showMessage={props.showMessage}
        saleType={"SALE"}
        paymentEvent={paymentEvent}
        setParentSaleBean={setParentSaleBean}
        terminalBean={props.terminalBean}
        setAlert={props.setAlert}
        onLogOut={props.onLogOut}
        setUuid={setUuid}
        uuid={uuid}
        setInvoiceNumber={setInvoiceNumber}
        clearServiceData={clearServiceData}
        setParentType={setParentType}
        holdMode={false}
        setHoldNote={setHoldNote}
        setCustomerBeanForHold={setCustomerBeanForHold}
        setLastBill={setLastBill}
        setShowLastSaleSummary={setShowLastSaleSummary}
        setShowPaymentScreen={setShowPaymentScreen}
        setPrivileges={setPrivileges}
        setCurrentUser={setCurrentUser}
        pdfViewer={props.pdfViewer}
        currentMenu={currentMenu}
        refreshQueue={refreshQueue}
        setSelectedQueue={setSelectedQueue}
        setworkflowStatus={setworkflowStatus}
        setTableInfo={setTableInfo}
        setSalesManInfo={setSalesManInfo}
        setTradingDate={setTradingDate}
        nextInvoiceNo={nextInvoiceNo}
        setNextInvoiceNo={setNextInvoiceNo}
        editMode={editMode}
        setEditMode={setEditMode}
        setTradingScreenPaymentModeSelect={setTradingScreenPaymentModeSelect}
      ></SaleDao>
      {/*For Hold and unhold*/}
      <SaleDao
        createPayload={createPayload}
        customerBean={customerBean}
        setCurrentScreen={setCurrentScreen}
        setSaleData={setSaleData}
        setRawSale={setRawSale}
        setCustomerBean={setCustomerBean}
        resetCustomFields={resetCustomFields}
        biRef={biRef2}
        context={props.context}
        showMessage={props.showMessage}
        saleType={props.saleType}
        paymentEvent={paymentEvent}
        setParentSaleBean={setParentSaleBean}
        terminalBean={props.terminalBean}
        setAlert={props.setAlert}
        onLogOut={props.onLogOut}
        setUuid={setUuid}
        setInvoiceNumber={setInvoiceNumber}
        clearServiceData={clearServiceData}
        setParentType={setParentType}
        holdMode={true}
        setShowHoldWindow={setShowHoldWindow}
        setHoldNote={setHoldNote}
        setCustomerBeanForHold={setCustomerBeanForHold}
        setPrivileges={setPrivileges}
        setCurrentUser={setCurrentUser}
        pdfViewer={props.pdfViewer}
        setSelectedQueue={setSelectedQueue}
        setworkflowStatus={setworkflowStatus}
        setTableInfo={setTableInfo}
        setSalesManInfo={setSalesManInfo}
        setTradingDate={setTradingDate}
        nextInvoiceNo={nextInvoiceNo}
        setNextInvoiceNo={setNextInvoiceNo}
        editMode={editMode}
        setEditMode={setEditMode}
        setTradingScreenPaymentModeSelect={setTradingScreenPaymentModeSelect}
      ></SaleDao>
      {showProductLookup && (
        <ProductLookup
          setShowProductLookup={setShowProductLookup}
          onAddProduct={onAddProduct}
          productCache={props.productCache}
          productCache2={props.productCache2}
          setAllowBarcodeScan={setAllowBarcodeScanFunc}
          context={props.context}
        ></ProductLookup>
      )}
      {showHoldWindow && (
        <HoldCrud
          biRef={biRef}
          customerBean={customerBean}
          showMessage={props.showMessage}
          setShowHoldWindow={setShowHoldWindow}
          createPayload={createPayload}
          saleType={props.saleType}
          showProgress={showProgress}
          onHold={onHold}
          setHoldNote={setHoldNote}
          customerBeanForHold={customerBeanForHold}
          setCustomerBeanForHold={setCustomerBeanForHold}
        ></HoldCrud>
      )}
      {showUnHoldWindow && (
        <UnHoldCrud
          biRef={biRef}
          customerBean={customerBean}
          showMessage={props.showMessage}
          setShowUnHoldWindow={setShowUnHoldWindow}
          saleType={props.saleType}
          handleSelectSale={handleSelectSale}
          handleSelectService={handleSelectService}
          setUuid={setUuid}
          setInvoiceNumber={setInvoiceNumber}
        ></UnHoldCrud>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {showCustomerLookupWindow && (
        <CustomerLookupNew
          biRef={biRef}
          customerBean={customerBean}
          setCustomerBean={setCustomerBean}
          showMessage={props.showMessage}
          setShowCustomerLookupWindow={setShowCustomerLookupWindow}
          setAlert={props.setAlert}
        />
      )}
      {showCustomerCrud && (
        <CustomerCrud
          biRef={biRef}
          showMessage={props.showMessage}
          setShowCustomerCrud={setShowCustomerCrud}
          context={props.context}
        ></CustomerCrud>
      )}
      {saleData.length == 0 && showLastSaleSummary && lastBill != null && (
        <LastSaleSummary
          lastBill={lastBill}
          closeLastSaleSummary={closeLastSaleSummary}
          context={props.context}
        ></LastSaleSummary>
      )}
      <Payin
        biRef={biRef}
        context={props.context}
        terminalId={props.terminalId}
        saleSession={props.saleSession}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        terminalBean={props.terminalBean}
        pdfViewer={props.pdfViewer}
      ></Payin>
      {showTableSelector && (
        <TableSelector
          setTableInfo={setTableInfo}
          context={props.context}
          closeWindow={setShowTableSelector}
          eventSource={tableSelectionEventSource}
        ></TableSelector>
      )}
      {showDeliveryPersonLookup && (
        <SalesManSelector
          setSalesManInfo={setSalesManInfo}
          context={props.context}
          closeWindow={seltShowDeliveryPersonLookup}
          deliveryPersons={deliveryPersons}
        ></SalesManSelector>
      )}
      {showAuthScreen && (
        <PAuthenticationWindow
          context={props.context}
          handleLoginSucessResponse={handleLoginSucessResponse}
          showWindow={setShowAuthScreen}
        ></PAuthenticationWindow>
      )}
      {confirmOpen && (
        <PConfirm
          maxWidth={"xs"}
          touchFriendly={true}
          fullWidth={true}
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProductSearch && (
        <ProductSearch
          showProductSearch={props.showProductSearch}
          context={props.context}
          setShowProductSearch={setShowProductSearch}
          productType={
            props.context.appType === "M_POS"
              ? "P"
              : props.context.appType === "R_POS"
              ? "R"
              : "I"
          }
        ></ProductSearch>
      )}
    </div>
  );
}
